/**
 * AUTO-GENERATED FILE. DO NOT EDIT.
 * Generated by vite-generate-links plugin on 2026-11-04T22:24:35.550Z.
 * Any changes will be overwritten.
 */

export interface LinkData {
	pathname: string
	name: string
}

export const links_map = new Map<number, LinkData>([
	[651036024, { pathname: '/', name: 'Home' }],
	[676144464, { pathname: '/', name: 'Layout' }],
	[64043980311734, { pathname: '/community', name: 'Community' }],
	[64044142423229, { pathname: '/community/our-staff', name: 'Our staff' }],
	[64044200299712, { pathname: '/community/our-staff/david-anson', name: 'David Anson' }],
	[64045628570891, { pathname: '/community/our-staff/', name: 'Our staff' }],
	[67916896772311, { pathname: '/introduction', name: 'Introduction' }],
	[67917015146712, { pathname: '/introduction/', name: 'An introduction' }],
	[67917580103897, { pathname: '/learning', name: 'Learning' }],
	[67917662449882, { pathname: '/living', name: 'Living' }],
	[67923476774507, { pathname: '/learning/', name: 'Learning' }],
	[68859192989463, { pathname: '/introduction/being-bedalian', name: 'Being Bedalian' }],
	[68860016921063, { pathname: '/introduction/heritage', name: 'Heritage' }],
	[68860250038743, { pathname: '/introduction/bedales-campus/', name: 'Bedales Campus' }],
	[68860374966858, { pathname: '/introduction/governance-and-policies', name: 'Governance & Policies' }],
	[69166699481807, { pathname: '/introduction/bedales-campus/lupton-hall', name: 'Lupton Hall' }],
	[69166984882907, { pathname: '/introduction/bedales-campus/sam-banks-pavilion', name: 'Sam Banks Pavilion' }],
	[
		69167162058576,
		{ pathname: '/introduction/bedales-campus/art-design-building', name: 'Art & Design Building' }
	],
	[69168061129814, { pathname: '/learning/pre-prep', name: 'Pre-Prep' }],
	[69168105759864, { pathname: '/learning/prep', name: 'Prep' }],
	[69168388736339, { pathname: '/learning/senior', name: 'Senior' }],
	[69168483767740, { pathname: '/learning/co-curricular', name: 'Co-curricular' }],
	[69174711570924, { pathname: '/learning/pre-prep/', name: 'Bedales Pre-Prep' }],
	[
		69178311355149,
		{ pathname: '/learning/pre-prep/pre-prep-approach-to-learning', name: 'Pre-prep approach to learning' }
	],
	[69178351868686, { pathname: '/learning/pre-prep/early-years', name: 'Early years:  Nursery & Reception' }],
	[69178388859664, { pathname: '/learning/pre-prep/years-1-3', name: 'Years 1-3' }],
	[70606796875393, { pathname: '/living/', name: 'Living' }],
	[70922447131106, { pathname: '/admissions', name: 'Admissions' }],
	[70922635665891, { pathname: '/admissions/', name: 'Admissions' }],
	[71617362774845, { pathname: '/admissions/apply-to-bedales/', name: 'Apply to Bedales' }],
	[71640297035339, { pathname: '/community/', name: 'Community' }],
	[71641903728335, { pathname: '/community/facilities-hire', name: 'Facilities hire' }],
	[71652642170913, { pathname: '/admissions/apply-to-bedales/enquiry-form', name: 'Enquiry form' }],
	[71721153421688, { pathname: '/contact-us', name: 'Contact us' }],
	[71723527687610, { pathname: '/environment', name: 'Environment' }],
	[71723574177244, { pathname: '/environment/', name: 'Environment' }],
	[71724951365989, { pathname: '/learning/senior/life-at-bedales-senior', name: 'Life at Bedales Senior' }],
	[71729757406441, { pathname: '/admissions/fees', name: 'Fees' }],
	[71730010961137, { pathname: '/admissions/scholarships-and-bursaries', name: 'Scholarships and bursaries' }],
	[71730776352418, { pathname: '/admissions/international-admissions', name: 'International admissions' }],
	[71731292692657, { pathname: '/admissions/visit-us/', name: 'Visit us' }],
	[71746983011373, { pathname: '/living/safeguarding/', name: 'Safeguarding' }],
	[71764084388273, { pathname: '/living/boarding-at-bedales', name: 'Boarding at Bedales' }],
	[71767202878104, { pathname: '/living/day-students', name: 'Day students' }],
	[71796663592675, { pathname: '/learning/senior/', name: 'Bedales Senior' }],
	[71796767486970, { pathname: '/learning/prep/', name: 'Bedales Prep' }],
	[72126546172471, { pathname: '/living/bedales-service', name: 'Bedales Service' }],
	[72509944580204, { pathname: '/living/wellbeing-pastoral-care', name: 'Wellbeing & Pastoral care' }],
	[72515770270263, { pathname: '/learning/senior/curriculum', name: 'Curriculum' }],
	[72515864732216, { pathname: '/learning/senior/curriculum/art-design', name: 'Art & Design' }],
	[73416883993341, { pathname: '/community/alumni-hub/', name: 'Alumni hub' }],
	[73417195785186, { pathname: '/community/parents-association', name: 'Parents’ Association' }],
	[73417546648806, { pathname: '/community/activities-courses/', name: 'Activities & Courses' }],
	[73417778691475, { pathname: '/community/student-voice', name: 'Student Voice' }],
	[73418004147770, { pathname: '/community/partnerships', name: 'Partnerships' }],
	[73425533932903, { pathname: '/working-for-us', name: 'Working with us' }],
	[73428826558128, { pathname: '/term-dates', name: 'Term dates' }],
	[73438475286565, { pathname: '/learning/co-curricular/', name: 'Co-curricular' }],
	[74072561515689, { pathname: '/learning/senior/curriculum/dance-drama', name: 'Dance & Drama' }],
	[74176236309924, { pathname: '/journal', name: 'Journal' }],
	[74176744320448, { pathname: '/whats-on', name: 'What’s on' }],
	[74176769826247, { pathname: '/whats-on/', name: 'What’s on' }],
	[74177098669659, { pathname: '/support-us', name: 'Support us' }],
	[74177123896929, { pathname: '/support-us/', name: 'Support us' }],
	[74177263992453, { pathname: '/support-us/bedales-grants-trust-fund', name: 'Bedales Grants Trust Fund' }],
	[74177339395746, { pathname: '/support-us/john-badley-foundation', name: 'John Badley Foundation' }],
	[74177478504135, { pathname: '/support-us/bedales-shop', name: 'Bedales Shop' }],
	[74177557626588, { pathname: '/support-us/charitable-partners', name: 'Charitable partners' }],
	[74184580314992, { pathname: '/community/alumni-hub/alumni-profiles/', name: 'Alumni profiles' }],
	[
		74184663054212,
		{ pathname: '/community/activities-courses/bedales-cricket-club', name: 'Bedales Cricket club' }
	],
	[
		74185188497469,
		{ pathname: '/living/safeguarding/contact-safeguarding-team', name: 'Contact safeguarding team' }
	],
	[74185277528152, { pathname: '/living/safeguarding/useful-resources', name: 'Useful resources' }],
	[74185731733710, { pathname: '/learning/prep/prep-approach-to-learning', name: 'Prep approach to learning' }],
	[74185989216531, { pathname: '/learning/pre-prep/life-at-bedales-pre-prep', name: 'Life at Bedales Pre-prep' }],
	[74186082126124, { pathname: '/learning/prep/curriculum/', name: 'Prep Curriculum' }],
	[
		74186254358885,
		{ pathname: '/learning/senior/senior-approach-to-learning', name: 'Senior approach to learning' }
	],
	[74186321639806, { pathname: '/learning/senior/blocks-3-5', name: 'Blocks 3-5' }],
	[74186389563798, { pathname: '/learning/senior/sixth-form', name: 'Sixth Form' }],
	[74186468227503, { pathname: '/learning/senior/curriculum/', name: 'Senior Curriculum' }],
	[74246853111348, { pathname: '/learning/senior/academic-success', name: 'Academic Success' }],
	[
		74246962957946,
		{
			pathname: '/learning/senior/curriculum/bedales-assessed-courses-bacs-',
			name: 'Bedales Assessed Courses (BACs)'
		}
	],
	[74263256552101, { pathname: '/my-bedales', name: 'My Bedales' }],
	[74263670129520, { pathname: '/practical-information', name: 'Practical information' }],
	[74267854873170, { pathname: '/cookie-policy', name: 'Cookie Policy' }],
	[74267994219091, { pathname: '/terms-conditions', name: 'Terms & Conditions' }],
	[74268654645872, { pathname: '/admissions/visit-us/open-days-registration', name: 'Open Days registration' }],
	[
		74268752765553,
		{ pathname: '/admissions/visit-us/taster-days-registration', name: 'Taster Days registration' }
	],
	[74577665835633, { pathname: '/admissions/request-prospectus', name: 'Request Prospectus' }],
	[74613113518995, { pathname: '/privacy', name: 'Privacy' }],
	[
		74639910322207,
		{ pathname: '/introduction/bedales-campus/the-memorial-library', name: 'The Memorial Library' }
	],
	[
		74913722326416,
		{ pathname: '/learning/senior/curriculum/humanities-global-studies', name: 'Humanities & Global Studies' }
	],
	[
		75610144701528,
		{
			pathname: '/learning/co-curricular/activities-academic-societies',
			name: 'Activities & Academic Societies'
		}
	],
	[75943584651620, { pathname: '/journal/news', name: 'News' }],
	[75943586056549, { pathname: '/journal/blog', name: 'Blog' }],
	[
		75944364595817,
		{
			pathname: '/journal/news/enrichment-speakers-inspire-dunhurst',
			name: 'Enrichment speakers inspire at Dunhurst'
		}
	],
	[75944365337194, { pathname: '/journal/news/portraits-dunhurst', name: 'Portraits of Dunhurst' }],
	[
		75944366516843,
		{
			pathname: '/journal/news/call-artists-support-art-sale-aid-refugees',
			name: 'Call for artists to support Art Sale in aid of refugees'
		}
	],
	[
		75944367340140,
		{
			pathname: '/journal/news/dr-adam-rutherford-delivers-eckersley-lecture',
			name: 'Dr Adam Rutherford delivers Eckersley Lecture'
		}
	],
	[
		75944368130669,
		{
			pathname: '/journal/news/academic-achievement-and-pupil-wellbeing-colin-baty-head-bedales-prep-dunhurst',
			name: 'Academic achievement and pupil wellbeing - Colin Baty, Head of Bedales Prep, Dunhurst'
		}
	],
	[
		75944368925294,
		{
			pathname: '/journal/news/dunhurst-takes-part-rspb-big-schools-birdwatch',
			name: 'Dunhurst takes part in RSPB Big Schools’ Birdwatch'
		}
	],
	[
		75944369781359,
		{ pathname: '/journal/news/bedales-announces-new-head-0', name: 'Bedales announces new Head' }
	],
	[
		75944370563696,
		{
			pathname: '/journal/news/encouraging-dialogue-change-will-goldsmith',
			name: 'Encouraging a dialogue for change - Will Goldsmith'
		}
	],
	[
		75944371280497,
		{
			pathname: '/journal/news/breaking-news-schools-closing-early',
			name: 'Breaking news - Schools closing early'
		}
	],
	[
		75944372152946,
		{
			pathname: '/journal/news/art-sale-supporting-refugee-charity-8-march',
			name: 'Art Sale supporting refugee charity - 8 March'
		}
	],
	[
		75944373021299,
		{ pathname: '/journal/news/bedales-celebrates-world-book-day', name: 'Bedales celebrates World Book Day' }
	],
	[
		75944373791348,
		{
			pathname: '/journal/news/overwhelming-support-refugees-bedales-community-day',
			name: 'Overwhelming support for refugees on Bedales community day '
		}
	],
	[75944374766197, { pathname: '/journal/news/teaching-reading', name: 'Teaching reading' }],
	[75944375528054, { pathname: '/journal/news/celebrating-science-week', name: 'Celebrating Science Week ' }],
	[
		75944376224375,
		{ pathname: '/journal/news/bedales-new-servery-and-salad-bar', name: "Bedales' new servery and salad bar" }
	],
	[
		75944376879736,
		{
			pathname: '/journal/news/cricket-tour-prepares-bedales-prep-season-ahead',
			name: 'Cricket tour prepares Bedales Prep for season ahead'
		}
	],
	[
		75944377653881,
		{ pathname: '/journal/news/mental-health-awareness-week', name: 'Mental Health Awareness Week' }
	],
	[
		75944378555002,
		{
			pathname: '/journal/news/celebrating-creativity-community',
			name: 'Celebrating creativity in the community'
		}
	],
	[
		75944379292283,
		{
			pathname: '/journal/news/jubilee-celebrations-bedales-pre-prep',
			name: 'Jubilee celebrations at Bedales Pre-prep'
		}
	],
	[
		75944379964028,
		{
			pathname: '/journal/news/will-goldsmith-speaks-independent-school-management-plus',
			name: 'Will Goldsmith speaks to Independent School Management Plus'
		}
	],
	[
		75944380639869,
		{
			pathname: '/journal/news/bedales-prep-pupil-wins-global-young-journalist-award',
			name: 'Bedales Prep pupil wins Global Young Journalist Award'
		}
	],
	[
		75944381397630,
		{
			pathname: '/journal/news/bedales-celebrates-freedom-learn',
			name: "Bedales celebrates the 'freedom to learn'"
		}
	],
	[
		75944382110335,
		{
			pathname: '/journal/news/bedales-pre-prep-celebrates-world-ocean-day',
			name: 'Bedales Pre-prep celebrates World Ocean Day'
		}
	],
	[
		75944382970496,
		{
			pathname: '/journal/news/bedales-prep-dunhursts-end-term-celebrations',
			name: "Bedales Prep, Dunhurst's end of term celebrations"
		}
	],
	[
		75944383830657,
		{
			pathname: '/journal/news/end-term-festivities-celebrate-community-and-success-0',
			name: 'End of term festivities celebrate community and success'
		}
	],
	[
		75944384768642,
		{
			pathname: '/journal/news/bedales-students-celebrate-progression-prestigious-universities',
			name: 'Bedales students celebrate progression to prestigious universities '
		}
	],
	[
		75944385673859,
		{
			pathname: '/journal/news/bedales-students-benefit-unique-curriculum',
			name: 'Bedales students benefit from unique curriculum '
		}
	],
	[
		75944386550404,
		{
			pathname: '/journal/news/reflection-death-queen-elizabeth-ii',
			name: 'Reflection on the death of Queen Elizabeth II'
		}
	],
	[
		75944387418757,
		{
			pathname: '/journal/news/how-teach-events-national-significance-clare-jarmy-tes',
			name: 'How to teach events of national significance - Clare Jarmy in TES'
		}
	],
	[
		75944388160134,
		{ pathname: '/journal/news/bedales-takes-footsteps-fitzroy', name: 'Bedales takes Footsteps for FitzRoy' }
	],
	[75944389008007, { pathname: '/journal/news/badley-day-bedales-prep', name: 'Badley Day at Bedales Prep' }],
	[
		75944389855880,
		{
			pathname: '/journal/news/bedales-prep-and-pre-prep-celebrate-harvest-festival-0',
			name: 'Bedales Prep and Pre-prep celebrate Harvest Festival'
		}
	],
	[
		75944390625929,
		{
			pathname: '/journal/news/bedales-prep-dunhurst-marks-black-history-month',
			name: 'Bedales Prep, Dunhurst marks Black History Month'
		}
	],
	[
		75944391404170,
		{
			pathname: '/journal/news/celebrating-collaborative-achievements-outdoor-work-topping-out-ceremony',
			name: 'Celebrating collaborative achievements at Outdoor Work topping out ceremony'
		}
	],
	[
		75944392178315,
		{
			pathname: '/journal/news/bedales-comes-town-12-13-november',
			name: 'Bedales comes to town - 12-13 November'
		}
	],
	[
		75944392891020,
		{
			pathname: '/journal/news/bedales-pre-prep-pledges-support-endangered-red-panda',
			name: 'Bedales Pre-prep pledges support for endangered red panda'
		}
	],
	[75944393620109, { pathname: '/journal/news/bedales-remembers-2', name: 'Bedales remembers' }],
	[75944394345102, { pathname: '/journal/news/art-inspired-nature', name: 'Art inspired by nature' }],
	[
		75944395078287,
		{
			pathname: '/journal/news/bedales-and-bohunt-celebrate-partnership-activities',
			name: 'Bedales and Bohunt celebrate partnership activities '
		}
	],
	[75944395774608, { pathname: '/journal/news/wanted-john-badley-joggers', name: 'Wanted: John Badley Joggers' }],
	[
		75944396511889,
		{
			pathname: '/journal/thought-leadership/bedales-featured-bbc-its-humane-approach-boarding',
			name: "Bedales featured by BBC for its 'humane' approach to boarding"
		}
	],
	[
		75944397224594,
		{ pathname: '/journal/news/jbf-christmas-auction-now-live', name: 'JBF Christmas Auction now live' }
	],
	[
		75944398064275,
		{
			pathname: '/journal/news/supporting-refugees-through-bedales-discovery-day',
			name: 'Supporting refugees through the Bedales Discovery Day'
		}
	],
	[
		75944398875284,
		{
			pathname: '/journal/news/pastoral-pups-support-pupils-wellbeing-bedales-prep',
			name: "Pastoral pups support pupils' wellbeing at Bedales Prep"
		}
	],
	[
		75944399641237,
		{
			pathname: '/journal/news/coming-together-support-good-causes-0',
			name: 'Coming together to support good causes'
		}
	],
	[
		75944400349846,
		{
			pathname: '/journal/news/bedales-music-scholar-begins-national-youth-orchestra-residencies',
			name: 'Bedales music scholar begins National Youth Orchestra residencies'
		}
	],
	[
		75944401103511,
		{ pathname: '/journal/news/what-are-you-doing-others', name: '"What are you doing for others?"' }
	],
	[
		75944401930904,
		{
			pathname: '/journal/news/bedales-prep-host-iaps-small-school-football-championships',
			name: 'Bedales Prep host IAPS Small School Football Championships'
		}
	],
	[75944402688665, { pathname: '/journal/news/portrait-petersfield', name: 'A Portrait of Petersfield' }],
	[
		75944403483290,
		{ pathname: '/journal/thought-leadership/will-goldsmith-gcse-reform', name: 'Will Goldsmith on GCSE reform' }
	],
	[
		75944404253339,
		{
			pathname: '/journal/news/inspirational-prep-primary-school-music-day',
			name: 'Inspirational Prep & Primary School Music Day'
		}
	],
	[
		75944404933276,
		{
			pathname: '/journal/news/curriculum-enriching-trips-bedales-pre-prep',
			name: 'Curriculum enriching trips at Bedales Pre-prep'
		}
	],
	[
		75944405613213,
		{
			pathname: '/journal/news/bedales-prep-dunhurst-takes-part-rspb-big-schools-birdwatch',
			name: 'Bedales Prep, Dunhurst takes part in RSPB Big Schools’ Birdwatch '
		}
	],
	[
		75944406387358,
		{ pathname: '/journal/news/bedales-celebrates-world-book-day-0', name: 'Bedales celebrates World Book Day' }
	],
	[
		75944407349919,
		{
			pathname: '/journal/news/students-quiz-damian-hinds-mp-future-education',
			name: 'Students Quiz Damian Hinds, MP on the Future of Education'
		}
	],
	[
		75944408197792,
		{
			pathname: '/journal/news/heroic-efforts-bedales-runners-supporting-refugees',
			name: 'Heroic efforts by Bedales runners supporting refugees'
		}
	],
	[
		75944408947361,
		{
			pathname: '/journal/news/celebrating-king-charles-coronation',
			name: "Celebrating King Charles' Coronation"
		}
	],
	[
		75944409684642,
		{
			pathname: '/journal/news/bedales-prep-shortlisted-international-art-competition',
			name: 'Bedales Prep shortlisted in international art competition '
		}
	],
	[
		75944410360483,
		{
			pathname: '/journal/news/bedales-students-secure-places-prestigious-universities',
			name: 'Bedales students secure places at prestigious universities '
		}
	],
	[
		75944411073188,
		{
			pathname: '/journal/news/unique-bedales-curriculum-sits-alongside-gcses',
			name: 'Unique Bedales curriculum sits alongside GCSEs '
		}
	],
	[75944411798181, { pathname: '/journal/news/clare-jarmy-gcse-reform', name: 'Clare Jarmy on GCSE reform' }],
	[
		75944412568230,
		{
			pathname: '/journal/thought-leadership/bedales-sets-out-vision-next-decade',
			name: 'Bedales sets out vision for next decade'
		}
	],
	[
		75944413379239,
		{
			pathname: '/journal/news/bedales-prep-pupil-wins-junior-architect-competition',
			name: 'Bedales Prep pupil wins junior architect competition'
		}
	],
	[
		75944414100136,
		{
			pathname: '/journal/news/ob-marika-hackman-returns-film-music-video-bedales',
			name: 'OB Marika Hackman returns to film music video at Bedales'
		}
	],
	[75944414792361, { pathname: '/journal/news/front-page-news', name: 'Front page news' }],
	[
		75944415533738,
		{
			pathname: '/journal/news/bedales-big-bursary-walk-john-badley-foundation',
			name: 'Bedales’ Big Bursary Walk for the John Badley Foundation'
		}
	],
	[
		75944416348843,
		{
			pathname: '/journal/thought-leadership/bedales-curriculum-featured-report-all-party-parliamentary-group',
			name: 'Bedales curriculum featured in report by All Party Parliamentary Group'
		}
	],
	[
		75944417061548,
		{
			pathname: '/journal/news/celebrating-harvest-festival-bedales-prep-and-pre-prep',
			name: 'Celebrating Harvest Festival at Bedales Prep and Pre-prep'
		}
	],
	[
		75944417794733,
		{ pathname: '/journal/news/major-new-art-sale-announced', name: 'Major new Art Sale announced' }
	],
	[75944418552494, { pathname: '/journal/news/remembrance-bedales', name: 'Remembrance at Bedales ' }],
	[
		75944419453615,
		{
			pathname: '/journal/news/bedales-students-shortlisted-10-shot-film-awards',
			name: 'Bedales students shortlisted in 10 Shot Film Awards'
		}
	],
	[
		75944420190896,
		{
			pathname: '/journal/thought-leadership/bedales-featured-house-lords-report-education',
			name: 'Bedales featured in House of Lords report on education '
		}
	],
	[
		75944421010097,
		{
			pathname: '/journal/news/old-bedalian-mike-sadler-last-wartime-sas-originals',
			name: 'Old Bedalian Mike Sadler - last of the wartime SAS ‘Originals’  '
		}
	],
	[
		75944421710514,
		{
			pathname: '/journal/news/sharing-insights-future-education',
			name: 'Sharing insights on the future of education'
		}
	],
	[
		75944422435507,
		{
			pathname: '/journal/news/small-schools-arts-day-bedales-prep',
			name: 'Small Schools Arts Day at Bedales Prep'
		}
	],
	[
		75944423131828,
		{
			pathname: '/journal/news/assessments-post-pandemic-era-clare-jarmy-teaching-times',
			name: 'Assessments in the post-pandemic era - Clare Jarmy in Teaching Times'
		}
	],
	[
		75944423897781,
		{ pathname: '/journal/news/bedales-school-house-magazine', name: 'Bedales in School House Magazine' }
	],
	[
		75944424733366,
		{
			pathname: '/journal/news/bedales-blog-relocating-petersfield',
			name: 'Bedales blog: Relocating to Petersfield '
		}
	],
	[
		75944425716407,
		{ pathname: '/journal/news/big-line-hampshire-art-sale', name: 'Big line up for Hampshire Art Sale' }
	],
	[
		75944426535608,
		{ pathname: '/journal/thought-leadership/learning-lessons-globally', name: 'Learning lessons globally ' }
	],
	[75944427276985, { pathname: '/journal/news/celebrating-world-book-day', name: 'Celebrating World Book Day' }],
	[75944428071610, { pathname: '/journal/news/bedales-trailblazers', name: 'Bedales trailblazers ' }],
	[
		75944428858043,
		{
			pathname: '/journal/news/bedales-pre-prep-makes-waves-red-nose-day-swimathon',
			name: 'Bedales Pre-prep makes waves with Red Nose Day swimathon'
		}
	],
	[
		75944429566652,
		{
			pathname: '/journal/news/international-womens-day-bedales-prep',
			name: "International Women's Day at Bedales Prep "
		}
	],
	[
		75944430336701,
		{
			pathname: '/journal/news/bedales-launches-traditional-heritage-craft-week',
			name: 'Bedales launches Traditional Heritage Craft Week'
		}
	],
	[
		75944431176382,
		{
			pathname: '/journal/news/bedales-approach-highlighted-times',
			name: 'Bedales approach highlighted in The Times'
		}
	],
	[
		75944431921855,
		{
			pathname: '/journal/news/local-students-question-schools-minister',
			name: "Local students question Schools' Minister "
		}
	],
	[
		75944432605888,
		{
			pathname: '/journal/news/bedales-tennis-invites-applications-half-term-workshops',
			name: 'Bedales Tennis invites applications for half term workshops '
		}
	],
	[75944433314497, { pathname: '/journal/news/barking-bats-and-balls', name: 'Barking, Bats and Balls ' }],
	[
		75944434051778,
		{
			pathname: '/journal/thought-leadership/bedales-influencing-education-ft-article',
			name: 'Bedales influencing education – FT article '
		}
	],
	[
		75944434850499,
		{ pathname: '/journal/news/bedales-students-take-new-musical', name: 'Bedales students take on new musical' }
	],
	[75944435530436, { pathname: '/journal/news/camps-week-bedales-prep', name: 'Camps Week at Bedales Prep' }],
	[
		75944436218565,
		{ pathname: '/journal/thought-leadership/gcses-are-turning-pupils', name: '“GCSEs are turning pupils off”' }
	],
	[
		75944437004998,
		{
			pathname: '/journal/news/bedales-hosts-innovative-conference',
			name: 'Bedales hosts innovative conference'
		}
	],
	[75944437836487, { pathname: '/journal/news/end-term-celebrations', name: 'End of term celebrations ' }],
	[
		75944438606536,
		{
			pathname: '/journal/news/end-term-festivities-bedales-prep-and-pre-prep',
			name: 'End of term festivities at Bedales Prep and Pre-prep'
		}
	],
	[75944439323337, { pathname: '/journal/news/buildings-bedales', name: 'Buildings of Bedales' }],
	[
		75944440117962,
		{
			pathname: '/journal/thought-leadership/creating-critical-thinkers-bedales-pre-prep',
			name: 'Creating critical thinkers at Bedales Pre-prep '
		}
	],
	[
		75944440916683,
		{
			pathname: '/journal/news/bedales-innovation-recognised-edufuturists-independent-school-year-award',
			name: 'Bedales innovation recognised with Edufuturists Independent School of the Year award '
		}
	],
	[
		75944441617100,
		{
			pathname: '/journal/news/prestigious-university-destinations-bedales-students',
			name: 'Prestigious university destinations for Bedales students'
		}
	],
	[
		75944442350285,
		{
			pathname: '/journal/news/unique-bedales-curriculum-replacing-gcses',
			name: 'Unique Bedales curriculum replacing GCSEs '
		}
	],
	[
		75944443361998,
		{ pathname: '/journal/news/work-each-weal-all-action', name: "'Work of each for weal of all' in action " }
	],
	[
		75944444164815,
		{
			pathname: '/journal/news/global-opportunities-international-universities-roadshow',
			name: 'Global opportunities at the International Universities Roadshow '
		}
	],
	[
		75944444930768,
		{
			pathname: '/journal/news/bedales-musicians-collaborate-whole-school-concert',
			name: 'Bedales musicians collaborate for Whole School Concert '
		}
	],
	[
		75944445688529,
		{
			pathname:
				'/journal/thought-leadership/striving-quality-and-innovation-will-goldsmith-hmc-heads-international-conference-2024',
			name: "Striving for quality and innovation - Will Goldsmith at the HMC Heads' International Conference 2024"
		}
	],
	[
		75944446458579,
		{ pathname: '/journal/news/half-term-tennis-coaching-bedales', name: 'Half term tennis coaching at Bedales' }
	],
	[
		75944447158996,
		{
			pathname: '/journal/thought-leadership/bedales-and-innovation-will-goldsmith-conversation',
			name: 'Bedales and innovation - Will Goldsmith in conversation '
		}
	],
	[
		75944447916757,
		{ pathname: '/journal/thought-leadership/contributing-community', name: 'Contributing to the community ' }
	],
	[
		75944448776918,
		{
			pathname: '/journal/news/bedales-commemorates-remembrance-day',
			name: 'Bedales commemorates Remembrance Day '
		}
	],
	[
		75944449612503,
		{
			pathname:
				'/journal/thought-leadership/stars-are-aligned-decisive-action-will-goldsmith-governments-education-review',
			name: '“The stars are aligned for decisive action” – Will Goldsmith on the Government’s education review '
		}
	],
	[
		75944450493144,
		{
			pathname: '/journal/thought-leadership/evolution-or-revolution-fiona-read-rethinking-primary-curriculum',
			name: 'Evolution or revolution? Fiona Read on rethinking the primary curriculum'
		}
	],
	[
		75944451279577,
		{
			pathname: '/journal/thought-leadership/will-goldsmith-education-corner',
			name: 'Will Goldsmith in the Education Corner '
		}
	],
	[
		75944452094682,
		{
			pathname: '/journal/news/clare-kirkham-appointed-new-head-bedales-prep',
			name: 'Clare Kirkham appointed as new Head of Bedales Prep '
		}
	],
	[
		75944452897499,
		{ pathname: '/journal/thought-leadership/it-time-phase-out-gcses', name: 'Is it time to phase out GCSEs? ' }
	],
	[
		75944453671644,
		{
			pathname: '/journal/thought-leadership/broadening-skills-scientists-liz-stacy',
			name: 'Broadening skills for scientists - Liz Stacy'
		}
	],
	[
		75944454384349,
		{
			pathname: '/journal/news/popular-half-term-tennis-workshops-return',
			name: 'Popular half term tennis workshops return'
		}
	],
	[
		75944455101150,
		{
			pathname: '/journal/news/powerful-talk-marks-holocaust-memorial-day',
			name: 'Powerful talk marks Holocaust Memorial Day'
		}
	],
	[75944455830239, { pathname: '/journal/news/challenging-food-system', name: 'Challenging the food system' }],
	[
		75944456624864,
		{
			pathname: '/journal/news/bedales-rock-show-livestream-7-february-630pm',
			name: 'Bedales Rock Show livestream - 7 February, 6.30pm'
		}
	],
	[
		75944457353953,
		{
			pathname: '/journal/news/celebration-reading-world-book-day-2025',
			name: 'A celebration of reading - World Book Day 2025'
		}
	],
	[
		75944458013410,
		{
			pathname: '/journal/news/return-bedales-summer-hockey-fest',
			name: 'Return of the Bedales Summer Hockey Fest '
		}
	],
	[
		75944458709731,
		{ pathname: '/journal/news/new-bedales-podcast-launches', name: 'New Bedales Podcast launches' }
	],
	[
		75944459528932,
		{
			pathname: '/journal/news/peter-thackreys-mammoth-marathon-fundraiser-rowans-hospice',
			name: "Peter Thackrey's mammoth marathon fundraiser for Rowans Hospice "
		}
	],
	[
		75944460298981,
		{
			pathname: '/journal/news/new-season-bedales-events-autumnwinter-2025',
			name: 'New season of Bedales Events - Autumn/Winter 2025'
		}
	],
	[75944641510245, { pathname: '/journal/blog/rock-show-remember', name: 'A Rock Show to remember' }],
	[
		75944642259814,
		{ pathname: '/journal/blog/learning-craft-podcasting', name: 'Learning the craft of podcasting' }
	],
	[
		75944643115879,
		{ pathname: '/journal/blog/visiting-historic-battlefields', name: 'Visiting the historic battlefields' }
	],
	[
		75944643976040,
		{ pathname: '/journal/blog/refurbished-gym-opens-students', name: 'Refurbished gym opens to students' }
	],
	[
		75944644725612,
		{ pathname: '/journal/blog/carbon-offsetting-school-trips', name: 'Carbon offsetting school trips' }
	],
	[
		75944645483373,
		{
			pathname: '/journal/blog/concept-console-inspiration-video-game-art-director',
			name: 'From concept to console: inspiration from a video game art director'
		}
	],
	[
		75944646327150,
		{
			pathname: '/journal/blog/cybersecurity-ai-and-power-storytelling',
			name: 'Cybersecurity, AI and the power of storytelling'
		}
	],
	[
		75944647125871,
		{
			pathname: '/journal/blog/netball-players-developing-skill-and-strategy',
			name: 'Netball players developing in skill and strategy'
		}
	],
	[
		75944647834480,
		{
			pathname: '/journal/blog/bedales-senior-match-reports-week-ending-14-february-2025',
			name: 'Bedales Senior match reports - week ending 14 February 2025'
		}
	],
	[75944648690548, { pathname: '/journal/blog/careers-theatre', name: 'Careers in theatre' }],
	[
		75944649534325,
		{
			pathname: '/journal/blog/bedales-senior-match-reports-netball-24-february-28-march-2025',
			name: 'Bedales Senior match reports - Netball (24 February - 28 March 2025)'
		}
	],
	[
		75944650414966,
		{
			pathname: '/journal/blog/bedales-senior-match-reports-football-24-february-28-march-2025',
			name: 'Bedales Senior match reports - Football (24 February - 28 March 2025)'
		}
	],
	[
		75944651234167,
		{
			pathname: '/journal/blog/super-end-second-half-netball-season',
			name: 'A super end to the second half of the Netball season'
		}
	],
	[
		75944651914104,
		{
			pathname: '/journal/blog/61-spanish-level-and-enrichment-trip-barcelona',
			name: '6.1 Spanish A Level and Enrichment trip to Barcelona '
		}
	],
	[
		75944652680060,
		{
			pathname: '/journal/blog/bedales-hockey-boys-season-review',
			name: 'Bedales Hockey (Boys) - season in review'
		}
	],
	[
		75944653605757,
		{
			pathname: '/journal/blog/drama-and-dance-performance-write-ups-march-2025',
			name: 'Drama and Dance performance write-ups (March 2025)'
		}
	],
	[
		75944654482302,
		{
			pathname: '/journal/blog/forging-career-arts-sixth-form-enrichment-talk-ob-olivia-grant',
			name: 'Forging a Career in the Arts - Sixth Form Enrichment talk with OB Olivia Grant '
		}
	],
	[
		75944655301503,
		{
			pathname: '/journal/blog/girls-1st-xi-football-season-review',
			name: "Girls' 1st XI Football - Season review "
		}
	],
	[
		75944656022400,
		{ pathname: '/journal/blog/end-spring-term-music-roundup', name: 'End of Spring term Music roundup ' }
	],
	[
		75944656702340,
		{ pathname: '/journal/blog/62-v-staff-hockey-match-2025', name: '6.2 v Staff Hockey Match 2025' }
	],
	[75944657542021, { pathname: '/journal/blog/summer-term-outdoor-work', name: 'Summer term in Outdoor Work ' }],
	[
		75944658389894,
		{ pathname: '/journal/blog/bedales-dance-half-term-roundup', name: 'Bedales Dance half term roundup' }
	],
	[
		75944659254151,
		{ pathname: '/journal/blog/bedales-summer-hockey-fest-2025', name: 'Bedales Summer Hockey Fest 2025' }
	],
	[75944660077448, { pathname: '/journal/blog/pursuing-career-arts', name: 'Pursuing a career in the arts ' }],
	[
		75944660835212,
		{
			pathname: '/journal/blog/beyond-bedales-careers-events-may-2025',
			name: 'Beyond Bedales careers events - May 2025'
		}
	],
	[
		75944661683085,
		{
			pathname: '/journal/blog/fighting-keep-love-learning-alive',
			name: 'Fighting to keep the love of learning alive '
		}
	],
	[75944662797198, { pathname: '/journal/blog/half-term-music-roundup', name: 'Half term Music roundup ' }],
	[
		75944663657359,
		{
			pathname: '/journal/blog/61-devised-performances-enthralling-evening-entertainment',
			name: '6.1 Devised Performances - An enthralling evening of entertainment '
		}
	],
	[
		76240016566065,
		{ pathname: '/learning/senior/curriculum/maths-computer-science', name: 'Maths & Computer Science' }
	],
	[76248731753441, { pathname: '/learning/senior/curriculum/english', name: 'English' }],
	[76253747669802, { pathname: '/learning/senior/curriculum/languages-classics', name: 'Languages & Classics' }],
	[76264273406570, { pathname: '/learning/senior/curriculum/music', name: 'Music' }],
	[76319245763861, { pathname: '/learning/senior/curriculum/extended-projects', name: 'Extended Projects' }],
	[76319796389161, { pathname: '/learning/senior/curriculum/pshe-life-skills', name: 'PSHE Life Skills' }],
	[76322881183781, { pathname: '/learning/senior/curriculum/outdoor-work', name: 'Outdoor Work' }],
	[76361377964545, { pathname: '/journal/', name: 'Journal' }],
	[76388955067391, { pathname: '/journal/news/', name: 'News Hub' }],
	[76398266955665, { pathname: '/journal/thought-leadership/', name: 'Thought Leadership' }],
	[76893196768918, { pathname: '/learning/prep/life-at-bedales-prep', name: 'Life at Bedales Prep' }],
	[77728616239419, { pathname: '/learning/senior/curriculum/sport', name: 'Sport' }],
	[78517275454155, { pathname: '/whats-on/macbeth-0', name: 'Macbeth' }],
	[78700437010321, { pathname: '/learning/senior/curriculum/science', name: 'Science' }],
	[79434302277935, { pathname: '/learning/prep/curriculum', name: 'Curriculum' }],
	[79436545764136, { pathname: '/learning/prep/curriculum/art-design', name: 'Art & Design' }],
	[79444763335082, { pathname: '/learning/prep/curriculum/dance-drama', name: 'Drama and Dance' }],
	[79444817852850, { pathname: '/faqs', name: 'Frequently Asked Questions' }],
	[79468729756846, { pathname: '/learning/prep/curriculum/english', name: 'English' }],
	[
		79472849730516,
		{
			pathname: '/learning/prep/curriculum/geography-and-global-perspectives',
			name: 'Geography and Global Perspectives'
		}
	],
	[
		79476494853994,
		{
			pathname: '/learning/prep/curriculum/history-and-philosophy-religion-ethics',
			name: 'History and Philosophy, Religion & Ethics'
		}
	],
	[79477347404323, { pathname: '/learning/prep/curriculum/humanities', name: 'Humanities' }],
	[79479689320506, { pathname: '/learning/prep/curriculum/mathematics', name: 'Mathematics' }],
	[
		79481756894700,
		{ pathname: '/learning/prep/curriculum/modern-foreign-languages', name: 'Modern Foreign Languages' }
	],
	[79487251717253, { pathname: '/learning/prep/curriculum/music', name: 'Music' }],
	[79756298087330, { pathname: '/learning/prep/curriculum/outdoor-work', name: 'Outdoor Work' }],
	[79779900691476, { pathname: '/learning/prep/curriculum/science', name: 'Science' }],
	[79784932714874, { pathname: '/learning/prep/curriculum/sport', name: 'Sport' }],
	[79789977518297, { pathname: '/learning/prep/curriculum/life-skills-pshe', name: 'Life Skills & PSHE' }],
	[80154865408374, { pathname: '/enquire', name: 'Admissions enquiry' }],
	[80172105083120, { pathname: '/journal/galleries', name: 'Galleries' }],
	[80194376864924, { pathname: '/journal/galleries/61-drama-performances', name: '6.1 Drama Performances' }],
	[80194379666590, { pathname: '/journal/galleries/bedales-parents-day', name: "Bedales Parents' Day " }],
	[
		80194381100191,
		{
			pathname: '/journal/galleries/dunhurst-sports-day-and-parents-day',
			name: "Dunhurst Sports Day and Parents' Day"
		}
	],
	[80194382402720, { pathname: '/journal/galleries/kite-runner', name: 'The Kite Runner' }],
	[80194383750305, { pathname: '/journal/galleries/nursery-sports-day-2022', name: 'Nursery Sports Day 2022' }],
	[
		80194385159330,
		{ pathname: '/journal/galleries/reception-year-1-sports-day', name: 'Reception & Year 1 Sports Day' }
	],
	[80194386506915, { pathname: '/journal/galleries/year-2-3-sports-day', name: 'Year 2-3 Sports Day' }],
	[80194387924132, { pathname: '/journal/galleries/dunhurst-badley-day-2022', name: 'Dunhurst Badley Day 2022' }],
	[
		80194389238949,
		{
			pathname: '/journal/galleries/three-schools-concert-autumn-2022',
			name: "Three Schools' Concert Autumn 2022"
		}
	],
	[
		80194390676646,
		{ pathname: '/journal/galleries/lion-king-block-1-play', name: 'The Lion King (Block 1 Play)' }
	],
	[
		80194391930023,
		{
			pathname: '/journal/galleries/they-came-city-sixth-form-show',
			name: 'They Came to a City (Sixth Form Show)'
		}
	],
	[
		80194393384104,
		{ pathname: '/journal/galleries/bac-devised-performances-2022', name: 'BAC Devised Performances 2022' }
	],
	[
		80194394772649,
		{ pathname: '/journal/galleries/chicago-whole-school-show', name: 'Chicago (Whole School Show)' }
	],
	[
		80194396153002,
		{ pathname: '/journal/galleries/dunannie-christmas-carols', name: 'Dunannie Christmas Carols' }
	],
	[80194397557931, { pathname: '/journal/galleries/dunannie-nativity-2022', name: 'Dunannie Nativity 2022' }],
	[
		80194398868652,
		{
			pathname: '/journal/galleries/dunhurst-play-lion-witch-and-wardrobe',
			name: 'Dunhurst Play - The Lion, The Witch and the Wardrobe'
		}
	],
	[80194400220333, { pathname: '/journal/galleries/bedales-rock-show-2023', name: 'Bedales Rock Show 2023' }],
	[
		80194401670318,
		{
			pathname: '/journal/galleries/world-book-day-bedales-pre-prep-dunannie',
			name: 'World Book Day at Bedales Pre-prep, Dunannie'
		}
	],
	[80194402903215, { pathname: '/journal/galleries/bac-scripted-2023', name: 'BAC Scripted 2023' }],
	[
		80194404267184,
		{
			pathname: '/journal/galleries/bedales-prep-dunhurst-music-cabaret',
			name: 'Bedales Prep, Dunhurst Music Cabaret'
		}
	],
	[
		80194405696689,
		{ pathname: '/journal/galleries/bedales-dance-performs-2023', name: 'Bedales Dance Performs 2023' }
	],
	[
		80194406966450,
		{
			pathname: '/journal/galleries/62-devised-and-scripted-performances',
			name: '6.2 Devised and Scripted Performances'
		}
	],
	[
		80194408453299,
		{ pathname: '/journal/galleries/dunhurst-group-3-play-2023', name: 'Dunhurst Group 3 Play 2023' }
	],
	[
		80194409751732,
		{ pathname: '/journal/galleries/dunhurst-spring-concert-2023', name: 'Dunhurst Spring Concert 2023' }
	],
	[80194411115701, { pathname: '/journal/galleries/62-v-staff-hockey', name: '6.2 v Staff Hockey' }],
	[
		80194412528823,
		{
			pathname: '/journal/galleries/dunannie-coronation-celebration-picnic',
			name: 'Dunannie Coronation Celebration Picnic '
		}
	],
	[
		80194413868216,
		{
			pathname: '/journal/galleries/group-3-plays-all-sea-treasure-island',
			name: 'Group 3 Plays - All At Sea & Treasure Island'
		}
	],
	[80194415215801, { pathname: '/journal/galleries/outdoor-classroom-day', name: 'Outdoor Classroom Day' }],
	[80194416665786, { pathname: '/journal/galleries/parents-day-2023', name: "Parents' Day 2023" }],
	[80194417988795, { pathname: '/journal/galleries/hamper-ball-2023', name: 'Hamper Ball 2023' }],
	[
		80194419434684,
		{ pathname: '/journal/galleries/class-1983-40-year-reunion', name: 'Class of 1983 40 Year Reunion' }
	],
	[
		80194420925629,
		{ pathname: '/journal/galleries/bedales-prep-community-day', name: 'Bedales Prep Community Day' }
	],
	[80194422314174, { pathname: '/journal/galleries/badley-day-2023', name: 'Badley Day 2023' }],
	[
		80194423764159,
		{ pathname: '/journal/galleries/class-1973-50-year-reunion', name: 'Class of 1973 50 Year Reunion' }
	],
	[
		80194425038016,
		{
			pathname: '/journal/galleries/obs-vs-boys-first-xi-football-match-saturday-7-october-2023',
			name: "OBs vs Boys' First XI Football Match - Saturday 7 October 2023"
		}
	],
	[
		80194426397889,
		{ pathname: '/journal/galleries/bac-devised-performances-2023', name: 'BAC Devised Performances 2023' }
	],
	[
		80194427782338,
		{ pathname: '/journal/galleries/one-flew-over-cuckoos-nest', name: "One Flew Over the Cuckoo's Nest" }
	],
	[80194429220035, { pathname: '/journal/galleries/oliver-musical', name: 'Oliver! The Musical ' }],
	[
		80194430604484,
		{ pathname: '/journal/galleries/bac-scripted-february-2024', name: 'BAC Scripted - February 2024' }
	],
	[
		80194431960261,
		{
			pathname: '/journal/galleries/international-womens-day-bedales-prep',
			name: "International Women's Day at Bedales Prep "
		}
	],
	[
		80194433266886,
		{ pathname: '/journal/galleries/bedales-dance-performs-2024', name: 'Bedales Dance Performs 2024' }
	],
	[
		80194434680007,
		{
			pathname: '/journal/galleries/group-2-play-circus-delights',
			name: 'Group 2 Play - The Circus of Delights '
		}
	],
	[
		80194436072648,
		{
			pathname: '/journal/galleries/barking-bats-and-balls-friends-bedales-prep-and-pre-prep',
			name: 'Barking, Bats and Balls - Friends of Bedales Prep and Pre-prep '
		}
	],
	[
		80194437612746,
		{
			pathname: '/journal/galleries/61-drama-examination-performances',
			name: '6.1 Drama Examination Performances '
		}
	],
	[
		80194438890699,
		{ pathname: '/journal/galleries/75-ob-reunion-23-may-2024', name: '75+ OB Reunion - 23 May 2024 ' }
	],
	[
		80194440197324,
		{ pathname: '/journal/galleries/block-2-leavers-play-2024', name: "Block 2 Leavers' Play 2024" }
	],
	[
		80194441589965,
		{
			pathname: '/journal/galleries/bedales-prep-colour-run-june-2024',
			name: 'Bedales Prep Colour Run - June 2024 '
		}
	],
	[
		80194443019470,
		{
			pathname: '/journal/galleries/bedales-pre-prep-sports-day-years-1-2-and-3',
			name: 'Bedales Pre-prep Sports Day (Years 1, 2 and 3)'
		}
	],
	[
		80194444285135,
		{
			pathname: '/journal/galleries/bedales-pre-prep-sports-day-nursery-and-reception',
			name: 'Bedales Pre-prep Sports Day (Nursery and Reception)'
		}
	],
	[80194445743312, { pathname: '/journal/galleries/hamper-ball-2024-0', name: 'Hamper Ball 2024' }],
	[80194447086801, { pathname: '/journal/galleries/whole-school-show-rick', name: 'Whole School Show - Rick ' }],
	[80194448467154, { pathname: '/journal/galleries/parents-day-2024', name: "Parents' Day 2024" }],
	[
		80194449843411,
		{
			pathname: '/journal/galleries/ob-hugo-burge-memorial-tree-planting',
			name: 'OB Hugo Burge Memorial Tree Planting'
		}
	],
	[
		80194451215572,
		{
			pathname: '/journal/galleries/old-bedalian-reunions-summer-2024',
			name: 'Old Bedalian Reunions, Summer 2024'
		}
	],
	[80194452546773, { pathname: '/journal/galleries/badley-day-2024', name: 'Badley Day 2024' }],
	[
		80194453951702,
		{ pathname: '/journal/galleries/whole-school-concert-2024', name: 'Whole School Concert 2024' }
	],
	[
		80194455315671,
		{ pathname: '/journal/galleries/75-ob-reunion-october-2024', name: '75+ OB Reunion October 2024' }
	],
	[80194456691928, { pathname: '/journal/galleries/st-cecilia-concert-2024', name: 'St Cecilia Concert 2024 ' }],
	[
		80194457945305,
		{
			pathname: '/journal/galleries/first-xi-v-obs-football-match-november-2024',
			name: 'First XI v OBs Football Match November 2024 '
		}
	],
	[
		80194459370714,
		{
			pathname: '/journal/galleries/st-peters-concert-december-2024',
			name: "St Peter's Concert - December 2024 "
		}
	],
	[
		80194460730588,
		{
			pathname: '/journal/galleries/prep-school-show-addams-family',
			name: 'Prep School Show - The Addams Family '
		}
	],
	[80194462110941, { pathname: '/journal/galleries/steinway-piano-recital', name: 'Steinway Piano Recital' }],
	[
		80194463503582,
		{
			pathname: '/journal/galleries/prep-spring-concert-25-march-2025',
			name: 'Prep Spring Concert - 25 March 2025 '
		}
	],
	[
		80194464851167,
		{ pathname: '/journal/galleries/bedales-senior-sports-day-2025', name: 'Bedales Senior Sports Day 2025' }
	],
	[
		80194466243808,
		{ pathname: '/journal/galleries/ob-reunions-parents-day-2025', name: "OB Reunions Parents' Day 2025" }
	],
	[80194467775713, { pathname: '/journal/galleries/hamper-ball-2025', name: 'Hamper Ball 2025' }],
	[81510643557611, { pathname: '/journal/thought-leadership', name: 'Thought Leadership' }],
	[81619943609646, { pathname: '/learning/pre-prep/curriculum', name: 'Curriculum' }],
	[81620644324710, { pathname: '/learning/pre-prep/curriculum/expressive-arts', name: 'Expressive Arts' }],
	[81631097130966, { pathname: '/learning/pre-prep/curriculum/inquiry', name: 'Inquiry' }],
	[81717448438362, { pathname: '/learning/pre-prep/curriculum/life-skills', name: 'Life Skills' }],
	[81717521810011, { pathname: '/learning/pre-prep/curriculum/literacy', name: 'Literacy' }],
	[81718217810528, { pathname: '/learning/pre-prep/curriculum/maths', name: 'Maths' }],
	[
		81718881731172,
		{
			pathname: '/learning/pre-prep/curriculum/outdoor-work-forest-school',
			name: 'Outdoor Work & Forest School'
		}
	],
	[
		81719485112937,
		{ pathname: '/learning/pre-prep/curriculum/specialist-subjects', name: 'Specialist Subjects' }
	],
	[82270846445616, { pathname: '/whats-on/annual-theatre-ticket', name: 'Annual Theatre Ticket' }],
	[83471163709158, { pathname: '/journal/videos', name: 'Videos' }],
	[
		83488653223920,
		{ pathname: '/journal/videos/bedales-eswatini-project-2019', name: 'Bedales Eswatini Project 2019' }
	],
	[
		83488654637041,
		{
			pathname: '/journal/videos/bedales-rock-show-2020-lila-levingston',
			name: 'Bedales Rock Show 2020 - Lila Levingston'
		}
	],
	[
		83488656009202,
		{
			pathname: '/journal/videos/bedales-rock-show-2020-mabel-watson',
			name: 'Bedales Rock Show 2020 - Mabel Watson'
		}
	],
	[
		83488657393651,
		{
			pathname: '/journal/videos/bedales-rock-show-2020-isabella-montero',
			name: 'Bedales Rock Show 2020 - Isabella Montero'
		}
	],
	[
		83488658737140,
		{
			pathname: '/journal/videos/bedales-rock-show-2020-lara-rippinger',
			name: 'Bedales Rock Show 2020 - Lara Rippinger'
		}
	],
	[
		83488660076533,
		{
			pathname: '/journal/videos/george-vaux-feat-lara-rippinger-compatible',
			name: 'George Vaux feat. Lara Rippinger - Compatible'
		}
	],
	[
		83488661551094,
		{
			pathname: '/journal/videos/chilli-chilton-feat-tiger-braun-white-more-enough',
			name: 'Chilli Chilton feat. Tiger Braun-White - More Than Enough'
		}
	],
	[83488662874103, { pathname: '/journal/videos/jake-scott-looking-back', name: 'Jake Scott - Looking Back' }],
	[
		83488664258552,
		{ pathname: '/journal/videos/war-hypnotic-brass-ensemble', name: 'WAR - Hypnotic Brass Ensemble' }
	],
	[
		83488665651193,
		{
			pathname: '/journal/videos/safi-kazim-feat-tiger-braun-white-what-you-need',
			name: 'Safi Kazim feat. Tiger Braun-White - What You Need'
		}
	],
	[
		83488666994682,
		{
			pathname: '/journal/videos/isabella-montero-southern-comfort-zone-brad-paisley-cover',
			name: 'Isabella Montero - Southern Comfort Zone (Brad Paisley cover)'
		}
	],
	[
		83488668448763,
		{ pathname: '/journal/videos/august-janklow-blue-monday', name: 'August Janklow - Blue Monday ' }
	],
	[
		83488669890556,
		{
			pathname: '/journal/videos/sonnet-29-shakespeares-birthday',
			name: "'Sonnet 29' on Shakespeare's birthday"
		}
	],
	[
		83488671238141,
		{
			pathname: '/journal/videos/isabella-montero-underdog-alicia-keys-cover',
			name: "Isabella Montero - Underdog (Alicia Keys' cover)"
		}
	],
	[
		83488672511998,
		{
			pathname: '/journal/videos/gothic-literature-scenes-kipp-bryan',
			name: 'Gothic Literature scenes - Kipp Bryan'
		}
	],
	[83488674080767, { pathname: '/journal/videos/act-remembrance-2020', name: 'Act of Remembrance 2020' }],
	[
		83488675211264,
		{ pathname: '/journal/videos/bedales-summer-digital-rock-show', name: 'Bedales Summer Digital Rock Show' }
	],
	[
		83488676640769,
		{ pathname: '/journal/videos/bedales-summer-rock-show-chain', name: 'Bedales Summer Rock Show - The Chain' }
	],
	[
		83488678004738,
		{
			pathname: '/journal/videos/bedales-summer-rock-show-little-help-my-friends',
			name: 'Bedales Summer Rock Show - With A Little Help From My Friends'
		}
	],
	[
		83488679348227,
		{
			pathname: '/journal/videos/christmas-time-dont-let-bells-end',
			name: "Christmas Time (Don't Let the Bells End)"
		}
	],
	[
		83488680638468,
		{
			pathname: '/journal/videos/have-yourself-merry-little-christmas',
			name: 'Have Yourself A Merry Little Christmas'
		}
	],
	[83488682014725, { pathname: '/journal/videos/o-little-town-bethlehem', name: 'O Little Town of Bethlehem' }],
	[83488683481094, { pathname: '/journal/videos/carol-service', name: 'Bedales Carol Service 2020' }],
	[
		83488684845063,
		{ pathname: '/journal/videos/all-i-want-christmas-you', name: 'All I Want For Christmas Is You' }
	],
	[83488686237704, { pathname: '/journal/videos/christmas-wrapping', name: 'Christmas Wrapping' }],
	[83488687482889, { pathname: '/journal/videos/bac-devised-performances-1', name: 'BAC Devised Performances' }],
	[
		83488688904202,
		{ pathname: '/journal/videos/dunhurst-christmas-concert', name: 'Dunhurst Christmas Concert' }
	],
	[
		83488690243595,
		{ pathname: '/journal/videos/christmas-bedales-prep-dunhurst', name: 'Christmas at Bedales Prep, Dunhurst' }
	],
	[83488691738636, { pathname: '/journal/videos/christmas-time-bedales', name: 'Christmas Time at Bedales' }],
	[83488693045261, { pathname: '/journal/videos/jake-scott-fade-away', name: 'Jake Scott - Fade Away' }],
	[83488694360078, { pathname: '/journal/videos/butterfly-catcher', name: 'The Butterfly Catcher' }],
	[83488696236047, { pathname: '/journal/videos/red-red-rose', name: 'A Red, Red Rose' }],
	[83488697100304, { pathname: '/journal/videos/mouse', name: 'To A Mouse' }],
	[83488698505233, { pathname: '/journal/videos/block-3-book-reviews', name: 'Block 3 Book Reviews' }],
	[83488699787282, { pathname: '/journal/videos/block-4-gothic-films', name: 'Block 4 Gothic Films' }],
	[83488701167635, { pathname: '/journal/videos/block-4-bintrick-shots', name: 'Block 4 Bin/Trick Shots' }],
	[83488702658580, { pathname: '/journal/videos/making-frying-pan-pizza', name: 'How to Make Frying Pan Pizza' }],
	[83488703973397, { pathname: '/journal/videos/more-trick-shots', name: 'More Trick Shots' }],
	[
		83488705345558,
		{
			pathname: '/journal/videos/bright-star-would-i-were-stedfast-thou-art',
			name: 'Bright star, would I were stedfast as thou art'
		}
	],
	[83488706689047, { pathname: '/journal/videos/when-i-have-fears', name: 'When I Have Fears' }],
	[83488708053016, { pathname: '/journal/videos/treat-people-kindness', name: 'Treat People With Kindness' }],
	[83488709371929, { pathname: '/journal/videos/bedales-spring-concert', name: 'Bedales Spring Concert' }],
	[
		83488710854682,
		{ pathname: '/journal/videos/history-bedales-school-council', name: 'History of Bedales School Council' }
	],
	[
		83488712173595,
		{
			pathname: '/journal/videos/parents-day-virtual-art-design-exhibition',
			name: "Parents' Day Virtual Art & Design Exhibition"
		}
	],
	[
		83488713512988,
		{ pathname: '/journal/videos/bedales-scholars-concert-part-3', name: "Bedales Scholars' Concert: Part 3" }
	],
	[83488714987549, { pathname: '/journal/videos/cecilia-concert-2021', name: 'Cecilia Concert 2021' }],
	[
		83488716294174,
		{
			pathname: '/journal/videos/its-not-christmas-til-you-come-home',
			name: "It's Not Christmas 'Til You Come Home"
		}
	],
	[
		83488717637663,
		{ pathname: '/journal/videos/bedales-carol-service-2021', name: 'Bedales Carol Service 2021' }
	],
	[83488719108128, { pathname: '/journal/videos/gaudete', name: 'Gaudete' }],
	[
		83488720402465,
		{ pathname: '/journal/videos/bedales-carol-service-2022', name: 'Bedales Carol Service 2022' }
	],
	[83488721831970, { pathname: '/journal/videos/bedales-prep-dunhurst', name: 'Bedales Prep, Dunhurst' }],
	[
		83488723126307,
		{
			pathname: '/journal/videos/bedales-nursery-pre-prep-dunannie',
			name: 'Bedales Nursery & Pre-prep, Dunannie'
		}
	],
	[83488724539428, { pathname: '/journal/videos/oliver-musical', name: 'Oliver! The Musical ' }],
	[
		83488725936165,
		{ pathname: '/journal/videos/nursery-bedales-pre-prep', name: 'The Nursery at Bedales Pre-prep' }
	],
	[
		83488727275558,
		{ pathname: '/journal/videos/welcome-bedales-pre-prep-0', name: 'Welcome to Bedales Pre-prep' }
	],
	[
		83488728664103,
		{
			pathname: '/journal/videos/youth-dance-platform-2025-little-bit-wicked-bedales-prep-students',
			name: "Youth Dance Platform 2025: 'A Little Bit of Wicked' by Bedales Prep students"
		}
	],
	[83494013003619, { pathname: '/community/alumni-hub/alumni-profiles', name: 'Alumni profiles' }],
	[83528407881900, { pathname: '/whats-on/music-scholars-concert', name: "Music Scholars' Concert" }],
	[83528568072378, { pathname: '/whats-on/live-next-apollo', name: 'Live Next To The Apollo' }],
	[83531600180204, { pathname: '/community/alumni-hub/alumni-profiles/simon-anholt', name: 'Simon Anholt' }],
	[83531601495021, { pathname: '/community/alumni-hub/alumni-profiles/lucy-parham', name: 'Lucy Parham' }],
	[83531602842606, { pathname: '/community/alumni-hub/alumni-profiles/anna-dickerson', name: 'Anna Dickerson' }],
	[83531604181999, { pathname: '/community/alumni-hub/alumni-profiles/teddy-thompson', name: 'Teddy Thompson' }],
	[83531605603312, { pathname: '/community/alumni-hub/alumni-profiles/anthony-pike', name: 'Anthony Pike' }],
	[83531607213041, { pathname: '/community/alumni-hub/alumni-profiles/simon-hitchens', name: 'Simon Hitchens' }],
	[83531608364018, { pathname: '/community/alumni-hub/alumni-profiles/diana-armfield', name: 'Diana Armfield' }],
	[
		83531609764851,
		{ pathname: '/community/alumni-hub/alumni-profiles/roxanna-panufnik', name: 'Roxanna Panufnik' }
	],
	[83531611046900, { pathname: '/community/alumni-hub/alumni-profiles/jane-kirby', name: 'Jane Kirby' }],
	[83531612640245, { pathname: '/community/alumni-hub/alumni-profiles/john-russell', name: 'John Russell' }],
	[83531613852662, { pathname: '/community/alumni-hub/alumni-profiles/johnny-flynn', name: 'Johnny Flynn' }],
	[83531615163383, { pathname: '/community/alumni-hub/alumni-profiles/mella-shaw', name: 'Mella Shaw' }],
	[
		83531616494584,
		{ pathname: '/community/alumni-hub/alumni-profiles/dr-miranda-fricker', name: 'Dr Miranda Fricker' }
	],
	[83531617850361, { pathname: '/community/alumni-hub/alumni-profiles/pete-flood', name: 'Pete Flood' }],
	[83531619263482, { pathname: '/community/alumni-hub/alumni-profiles/alan-spivey', name: 'Alan Spivey' }],
	[
		83531620738043,
		{ pathname: '/community/alumni-hub/alumni-profiles/charles-cecil-mbe', name: 'Charles Cecil MBE' }
	],
	[83531622024188, { pathname: '/community/alumni-hub/alumni-profiles/emma-bentley', name: 'Emma Bentley' }],
	[83531623367677, { pathname: '/community/alumni-hub/alumni-profiles/edward-yeo', name: 'Edward Yeo' }],
	[83531624764414, { pathname: '/community/alumni-hub/alumni-profiles/arpit-vyas', name: 'Arpit Vyas' }],
	[83531626238975, { pathname: '/community/alumni-hub/alumni-profiles/felix-pickles', name: 'Felix Pickles' }],
	[83531627521024, { pathname: '/community/alumni-hub/alumni-profiles/jo-long', name: 'Jo Long' }],
	[83531628893185, { pathname: '/community/alumni-hub/alumni-profiles/hannah-newell', name: 'Hannah Newell' }],
	[83531630240770, { pathname: '/community/alumni-hub/alumni-profiles/james-harber', name: 'James Harber' }],
	[83531631621123, { pathname: '/community/alumni-hub/alumni-profiles/jenny-deletra', name: 'Jenny Deletra' }],
	[83531633021956, { pathname: '/community/alumni-hub/alumni-profiles/nina-kline', name: 'Nina Kline' }],
	[83531634373637, { pathname: '/community/alumni-hub/alumni-profiles/julian-coates', name: 'Julian Coates' }],
	[
		83531635700742,
		{ pathname: '/community/alumni-hub/alumni-profiles/henrique-dolabella', name: 'Henrique Dolabella' }
	],
	[
		83531637060615,
		{ pathname: '/community/alumni-hub/alumni-profiles/rodger-abey-parris', name: 'Rodger Abey-Parris' }
	],
	[83531638490120, { pathname: '/community/alumni-hub/alumni-profiles/india-hamilton', name: 'India Hamilton' }],
	[83531639821321, { pathname: '/community/alumni-hub/alumni-profiles/harriet-logan', name: 'Harriet Logan' }],
	[83531641242634, { pathname: '/community/alumni-hub/alumni-profiles/robin-nuttall', name: 'Robin Nuttall' }],
	[83531642541067, { pathname: '/community/alumni-hub/alumni-profiles/ebishop', name: 'Eva Bishop' }],
	[83531643950092, { pathname: '/community/alumni-hub/alumni-profiles/lucy-holmes', name: 'Lucy Holmes' }],
	[
		83531645301773,
		{ pathname: '/community/alumni-hub/alumni-profiles/naomi-rokotnitz', name: 'Naomi Rokotnitz' }
	],
	[83531646702606, { pathname: '/community/alumni-hub/alumni-profiles/nic-dunlop', name: 'Nic Dunlop' }],
	[83531648058383, { pathname: '/community/alumni-hub/alumni-profiles/gautam-lewis', name: 'Gautam Lewis' }],
	[83531649528848, { pathname: '/community/alumni-hub/alumni-profiles/monty-waldin', name: 'Monty Waldin' }],
	[83531650860049, { pathname: '/community/alumni-hub/alumni-profiles/charles-bevan', name: 'Charles Bevan' }],
	[83531652191250, { pathname: '/community/alumni-hub/alumni-profiles/amy-meadows', name: 'Amy Meadows' }],
	[83531653530643, { pathname: '/community/alumni-hub/alumni-profiles/tim-crocker', name: 'Tim Crocker' }],
	[83531654956052, { pathname: '/community/alumni-hub/alumni-profiles/mark-hanson', name: 'Mark Hanson' }],
	[83531656283157, { pathname: '/community/alumni-hub/alumni-profiles/grace-banks', name: 'Grace Banks' }],
	[83531657692182, { pathname: '/community/alumni-hub/alumni-profiles/gini-arnold', name: 'Gini Arnold' }],
	[83531658949655, { pathname: '/community/alumni-hub/alumni-profiles/ian-ripper', name: 'Ian Ripper' }],
	[83531660424216, { pathname: '/community/alumni-hub/alumni-profiles/jeremy-wates', name: 'Jeremy Wates' }],
	[
		83531661771801,
		{ pathname: '/community/alumni-hub/alumni-profiles/valerie-st-pierre', name: 'Valerie St. Pierre' }
	],
	[
		83531663148058,
		{ pathname: '/community/alumni-hub/alumni-profiles/patricia-duncker', name: 'Patricia Duncker' }
	],
	[83531664471067, { pathname: '/community/alumni-hub/alumni-profiles/ben-matthews', name: 'Ben Matthews' }],
	[83531665912860, { pathname: '/community/alumni-hub/alumni-profiles/michael-bird', name: 'Michael Bird' }],
	[
		83531667354653,
		{ pathname: '/community/alumni-hub/alumni-profiles/christy-callaway-gale', name: 'Christy Callaway-Gale' }
	],
	[
		83531668640798,
		{ pathname: '/community/alumni-hub/alumni-profiles/lucinda-montefiore', name: 'Lucinda Montefiore' }
	],
	[83531670045727, { pathname: '/community/alumni-hub/alumni-profiles/henry-danowski', name: 'Henry Danowski' }],
	[
		83531671381024,
		{ pathname: '/community/alumni-hub/alumni-profiles/philippa-rowland', name: 'Philippa Rowland' }
	],
	[83531672708129, { pathname: '/community/alumni-hub/alumni-profiles/kaveh-zahedi', name: 'Kaveh Zahedi' }],
	[83531674125346, { pathname: '/community/alumni-hub/alumni-profiles/peter-farrell', name: 'Peter Farrell' }],
	[83531675632675, { pathname: '/community/alumni-hub/alumni-profiles/eric-lawrie', name: 'Eric Lawrie' }],
	[
		83531676832804,
		{ pathname: '/community/alumni-hub/alumni-profiles/sirio-quintavalle', name: 'Sirio Quintavalle' }
	],
	[83531678159909, { pathname: '/community/alumni-hub/alumni-profiles/peter-harris', name: 'Peter Harris' }],
	[83531679605798, { pathname: '/community/alumni-hub/alumni-profiles/zoe-riddell', name: 'Zoe Riddell' }],
	[83531680928807, { pathname: '/community/alumni-hub/alumni-profiles/julien-beynon', name: 'Julien Beynon' }],
	[83531682260008, { pathname: '/community/alumni-hub/alumni-profiles/emily-whitley', name: 'Emily Whitley' }],
	[83531683673129, { pathname: '/community/alumni-hub/alumni-profiles/flo-stiff', name: 'Flo Stiff' }],
	[83531685176362, { pathname: '/community/alumni-hub/alumni-profiles/ben-nicolson', name: 'Ben Nicolson' }],
	[83531686380587, { pathname: '/community/alumni-hub/alumni-profiles/guy-griffin', name: ' Guy Griffin' }],
	[83531687752748, { pathname: '/community/alumni-hub/alumni-profiles/alice-clark', name: 'Alice Clark' }],
	[
		83531689198637,
		{ pathname: '/community/alumni-hub/alumni-profiles/tom-ward-thomas', name: 'Tom Ward-Thomas' }
	],
	[
		83531690595374,
		{
			pathname: '/community/alumni-hub/alumni-profiles/lachlan-marais-gilchrist',
			name: 'Lachlan Marais-Gilchrist'
		}
	],
	[83531691877423, { pathname: '/community/alumni-hub/alumni-profiles/anna-fox', name: 'Anna Fox' }],
	[83531693429808, { pathname: '/community/alumni-hub/alumni-profiles/phoebe-dabo', name: 'Phoebe d’Abo' }],
	[83531694703665, { pathname: '/community/alumni-hub/alumni-profiles/harriet-lane', name: 'Harriet Lane' }],
	[
		83531696079922,
		{ pathname: '/community/alumni-hub/alumni-profiles/joanna-tomlinson', name: 'Joanna Tomlinson' }
	],
	[83531697407027, { pathname: '/community/alumni-hub/alumni-profiles/ben-thompson', name: 'Ben Thompson' }],
	[83531698902068, { pathname: '/community/alumni-hub/alumni-profiles/oliver-holmes', name: 'Oliver Holmes' }],
	[83531700163637, { pathname: '/community/alumni-hub/alumni-profiles/laura-greene', name: 'Laura Greene' }],
	[83531701564470, { pathname: '/community/alumni-hub/alumni-profiles/gary-skinner', name: 'Gary Skinner' }],
	[83531702862903, { pathname: '/community/alumni-hub/alumni-profiles/kemi-williams', name: 'Kemi Williams ' }],
	[83531704206392, { pathname: '/community/alumni-hub/alumni-profiles/maurice-snell', name: 'Maurice Snell' }],
	[83531705603129, { pathname: '/community/alumni-hub/alumni-profiles/sarah-harber', name: 'Sarah Harber' }],
	[83531706872890, { pathname: '/community/alumni-hub/alumni-profiles/elly-whittaker', name: 'Elly Whittaker' }],
	[83531708249147, { pathname: '/community/alumni-hub/alumni-profiles/jamie-mcivor', name: 'Jamie McIvor' }],
	[83531709695036, { pathname: '/community/alumni-hub/alumni-profiles/olivia-grant', name: 'Olivia Grant' }],
	[
		83531711099965,
		{ pathname: '/community/alumni-hub/alumni-profiles/victoria-knight', name: 'Victoria Knight' }
	],
	[83531712402494, { pathname: '/community/alumni-hub/alumni-profiles/seth-mason', name: 'Seth Mason' }],
	[
		83531713729599,
		{ pathname: '/community/alumni-hub/alumni-profiles/becca-willoughby', name: 'Becca Willoughby' }
	],
	[
		83531715150912,
		{ pathname: '/community/alumni-hub/alumni-profiles/george-thatcher', name: 'George Thatcher' }
	],
	[83531716617281, { pathname: '/community/alumni-hub/alumni-profiles/janet-dwyer', name: 'Janet Dwyer ' }],
	[
		83531717960770,
		{ pathname: '/community/alumni-hub/alumni-profiles/george-alldridge', name: 'George Alldridge' }
	],
	[83531719316547, { pathname: '/community/alumni-hub/alumni-profiles/albie-waterton', name: 'Albie Waterton' }],
	[
		83531720655940,
		{ pathname: '/community/alumni-hub/alumni-profiles/michael-carr-gregg', name: 'Michael Carr-Gregg ' }
	],
	[83531722101829, { pathname: '/community/alumni-hub/alumni-profiles/alan-lucas', name: 'Alan Lucas' }],
	[83531723383878, { pathname: '/community/alumni-hub/alumni-profiles/dorian-lowell', name: 'Dorian Lowell ' }],
	[83531724809287, { pathname: '/community/alumni-hub/alumni-profiles/peter-hall-am', name: 'Peter Hall AM' }],
	[83531726144584, { pathname: '/community/alumni-hub/alumni-profiles/zoe-warshaw', name: 'Zoe Warshaw' }],
	[83531727496265, { pathname: '/community/alumni-hub/alumni-profiles/thomas-elwes', name: 'Thomas Elwes' }],
	[83531728909386, { pathname: '/community/alumni-hub/alumni-profiles/jack-westgarth', name: 'Jack Westgarth' }],
	[
		83531730183243,
		{ pathname: '/community/alumni-hub/alumni-profiles/arran-marais-gilchrist', name: 'Arran Marais-Gilchrist' }
	],
	[83531731682380, { pathname: '/community/alumni-hub/alumni-profiles/adam-hemmings', name: 'Adam Hemmings' }],
	[83531732952141, { pathname: '/community/alumni-hub/alumni-profiles/alice-holmes', name: 'Alice Holmes' }],
	[83531734312014, { pathname: '/community/alumni-hub/alumni-profiles/tilly-wheating', name: 'Tilly Wheating' }],
	[
		83531735692367,
		{ pathname: '/community/alumni-hub/alumni-profiles/kit-onslow-smith', name: 'Kit Onslow Smith' }
	],
	[
		83531737117776,
		{ pathname: '/community/alumni-hub/alumni-profiles/remy-blumenfeld', name: 'Remy Blumenfeld ' }
	],
	[83531738522705, { pathname: '/community/alumni-hub/alumni-profiles/ben-browne', name: 'Ben Browne' }],
	[
		83531739821138,
		{ pathname: '/community/alumni-hub/alumni-profiles/lysander-ashton', name: 'Lysander Ashton ' }
	],
	[83531741275219, { pathname: '/community/alumni-hub/alumni-profiles/mira-mina', name: 'Mira Mina ' }],
	[83531742549076, { pathname: '/community/alumni-hub/alumni-profiles/joe-oconnor', name: 'Joe O’Connor ' }],
	[83531743966293, { pathname: '/community/alumni-hub/alumni-profiles/nimmy-march', name: 'Nimmy March' }],
	[
		83531745375318,
		{ pathname: '/community/alumni-hub/alumni-profiles/matthew-batstone', name: 'Matthew Batstone' }
	],
	[83531746616407, { pathname: '/community/alumni-hub/alumni-profiles/akeay', name: 'Anna Keay ' }],
	[83531748103256, { pathname: '/community/alumni-hub/alumni-profiles/jhardy', name: 'Joanna Hardy ' }],
	[83531749491801, { pathname: '/community/alumni-hub/alumni-profiles/clare-mccaldin', name: 'Clare McCaldin' }],
	[83531750818906, { pathname: '/community/alumni-hub/alumni-profiles/andy-kemp', name: 'Andy Kemp ' }],
	[83531752047707, { pathname: '/community/alumni-hub/alumni-profiles/lorne-st-clair', name: 'Lorne St Clair' }],
	[83531753448540, { pathname: '/community/alumni-hub/alumni-profiles/jack-deane', name: 'Jack Deane ' }],
	[83531754906717, { pathname: '/community/alumni-hub/alumni-profiles/lerato-islam', name: 'Lerato Islam  ' }],
	[83531756262494, { pathname: '/community/alumni-hub/alumni-profiles/edward-weldon', name: 'Edward Weldon ' }],
	[83531757638751, { pathname: '/community/alumni-hub/alumni-profiles/ned-lay', name: 'Ned Lay ' }],
	[
		83531758994528,
		{ pathname: '/community/alumni-hub/alumni-profiles/harvey-patchett-joyce', name: 'Harvey Patchett-Joyce ' }
	],
	[
		83531760411745,
		{ pathname: '/community/alumni-hub/alumni-profiles/sebastian-bergne', name: 'Sebastian Bergne ' }
	],
	[
		83531761661026,
		{ pathname: '/community/alumni-hub/alumni-profiles/angie-mclachlan', name: 'Angie McLachlan' }
	],
	[83531763106915, { pathname: '/community/alumni-hub/alumni-profiles/hgourlay', name: 'Hannah Gourlay' }],
	[83531764483172, { pathname: '/community/alumni-hub/alumni-profiles/zoe-graham', name: 'Zoe Graham' }],
	[83531765789797, { pathname: '/community/alumni-hub/alumni-profiles/mharper', name: 'Mary Harper' }],
	[
		83531767235686,
		{ pathname: '/community/alumni-hub/alumni-profiles/christopher-pietroni', name: 'Christopher Pietroni ' }
	],
	[83531768648807, { pathname: '/community/alumni-hub/alumni-profiles/jonathan-klein', name: 'Jonathan Klein' }],
	[
		83531769922664,
		{ pathname: '/community/alumni-hub/alumni-profiles/florence-robson', name: 'Florence Robson' }
	],
	[83531771253865, { pathname: '/community/alumni-hub/alumni-profiles/naomi-pauling', name: 'Naomi Pauling' }],
	[83531772712042, { pathname: '/community/alumni-hub/alumni-profiles/laurence-moore', name: 'Laurence Moore' }],
	[
		83531774039147,
		{ pathname: '/community/alumni-hub/alumni-profiles/ella-clayton-bell', name: 'Ella Clayton Bell ' }
	],
	[
		83531775444076,
		{ pathname: '/community/alumni-hub/alumni-profiles/charlotte-glass', name: 'Charlotte Glass' }
	],
	[83531776787565, { pathname: '/community/alumni-hub/alumni-profiles/lucy-johnson', name: 'Lucy Johnson' }],
	[83531778417774, { pathname: '/community/alumni-hub/alumni-profiles/george-impey', name: 'George Impey' }],
	[83531779650671, { pathname: '/community/alumni-hub/alumni-profiles/nathalie-mares', name: 'Nathalie Mares' }],
	[83531781022832, { pathname: '/community/alumni-hub/alumni-profiles/charles-pitman', name: 'Charles Pitman' }],
	[
		83531782378609,
		{ pathname: '/community/alumni-hub/alumni-profiles/duncan-ryn-gough', name: 'Duncan Ryn Gough' }
	],
	[83531783758962, { pathname: '/community/alumni-hub/alumni-profiles/peter-cabrera', name: 'Peter Cabrera' }],
	[83531785155699, { pathname: '/community/alumni-hub/alumni-profiles/andrew-steed', name: 'Andrew Steed' }],
	[83531786372212, { pathname: '/community/alumni-hub/alumni-profiles/harriet-selka', name: 'Harriet Selka' }],
	[83531787789429, { pathname: '/community/alumni-hub/alumni-profiles/brooke-theis', name: 'Brooke Theis' }],
	[83531789104246, { pathname: '/community/alumni-hub/alumni-profiles/emelie-rice', name: 'Emelie Rice' }],
	[83531790607479, { pathname: '/community/alumni-hub/alumni-profiles/adam-kent', name: 'Adam Kent' }],
	[
		83531791918200,
		{ pathname: '/community/alumni-hub/alumni-profiles/lara-johnson-wheeler', name: 'Lara Johnson-Wheeler' }
	],
	[83531793253497, { pathname: '/community/alumni-hub/alumni-profiles/jimmy-morris', name: 'Jimmy Morris' }],
	[
		83531794715770,
		{ pathname: '/community/alumni-hub/alumni-profiles/katharine-jasinski', name: 'Katharine Jasinski' }
	],
	[83531796055163, { pathname: '/community/alumni-hub/alumni-profiles/alana-hurd', name: 'Alana Hurd' }],
	[83531797402748, { pathname: '/community/alumni-hub/alumni-profiles/abullus', name: 'Anna Bullus' }],
	[83531798692989, { pathname: '/community/alumni-hub/alumni-profiles/afargher', name: 'Anna Fargher' }],
	[83531800163454, { pathname: '/community/alumni-hub/alumni-profiles/john-hitchens', name: 'John Hitchens' }],
	[83531801551999, { pathname: '/community/alumni-hub/alumni-profiles/mark-bromley', name: 'Mark Bromley' }],
	[83531802891392, { pathname: '/community/alumni-hub/alumni-profiles/miriam-morris', name: 'Miriam Morris' }],
	[83531804259457, { pathname: '/community/alumni-hub/alumni-profiles/jean-gooder', name: 'Jean Gooder ' }],
	[83531805680770, { pathname: '/community/alumni-hub/alumni-profiles/jenny-hilton', name: 'Jenny Hilton' }],
	[
		83531806999683,
		{ pathname: '/community/alumni-hub/alumni-profiles/mary-hollingsworth', name: 'Mary Hollingsworth ' }
	],
	[83531808404612, { pathname: '/community/alumni-hub/alumni-profiles/matthew-rice', name: 'Matthew Rice' }],
	[83531809764485, { pathname: '/community/alumni-hub/alumni-profiles/tom-lodge', name: 'Tom Lodge' }],
	[83531811120262, { pathname: '/community/alumni-hub/alumni-profiles/diana-ambache', name: 'Diana Ambache' }],
	[
		83531812512903,
		{
			pathname: '/community/alumni-hub/alumni-profiles/alison-berman-nee-press',
			name: 'Alison Berman née Press '
		}
	],
	[
		83531813917832,
		{ pathname: '/community/alumni-hub/alumni-profiles/cathy-baxandall', name: 'Cathy Baxandall' }
	],
	[83531815285897, { pathname: '/community/alumni-hub/alumni-profiles/judith-herrin', name: 'Judith Herrin' }],
	[83531816588426, { pathname: '/community/alumni-hub/alumni-profiles/joshua-grubb', name: 'Joshua Grubb' }],
	[83531818022027, { pathname: '/community/alumni-hub/alumni-profiles/tristan-farran', name: 'Tristan Farran' }],
	[83531819259020, { pathname: '/community/alumni-hub/alumni-profiles/rachael-emsley', name: 'Rachael Emsley' }],
	[
		83531820815501,
		{ pathname: '/community/alumni-hub/alumni-profiles/sylvain-lefebvre', name: 'Sylvain Lefebvre' }
	],
	[
		83531822101646,
		{ pathname: '/community/alumni-hub/alumni-profiles/oscar-braun-white', name: 'Oscar Braun-White' }
	],
	[83531823490191, { pathname: '/community/alumni-hub/alumni-profiles/emma-sueref', name: 'Emma Sueref' }],
	[83531824784528, { pathname: '/community/alumni-hub/alumni-profiles/joshua-white', name: 'Joshua White' }],
	[83531826201745, { pathname: '/community/alumni-hub/alumni-profiles/hal-currey', name: 'Hal Currey' }],
	[83531827512466, { pathname: '/community/alumni-hub/alumni-profiles/katrina-rivers', name: 'Katrina Rivers' }],
	[83531828876435, { pathname: '/community/alumni-hub/alumni-profiles/emma-cusworth', name: 'Emma Cusworth' }],
	[83531830342804, { pathname: '/community/alumni-hub/alumni-profiles/catriona-ward', name: 'Catriona Ward' }],
	[83531831592085, { pathname: '/community/alumni-hub/alumni-profiles/julia-catton', name: 'Julia Catton' }],
	[83531832997014, { pathname: '/community/alumni-hub/alumni-profiles/john-ridding', name: 'John Ridding' }],
	[
		83531834414231,
		{ pathname: '/community/alumni-hub/alumni-profiles/jonathan-taylor', name: 'Jonathan Taylor' }
	],
	[83531835770008, { pathname: '/community/alumni-hub/alumni-profiles/tanya-ashken', name: 'Tanya Ashken ' }],
	[
		83531837191321,
		{ pathname: '/community/alumni-hub/alumni-profiles/georgia-glynn-smith', name: 'Georgia Glynn Smith ' }
	],
	[83531838530714, { pathname: '/community/alumni-hub/alumni-profiles/tilly-blyth', name: 'Tilly Blyth' }],
	[84085570774760, { pathname: '/journal/podcast', name: 'Bedales Podcast' }],
	[84447062017947, { pathname: '/community/our-staff/camilla-bell', name: 'Camilla Bell' }],
	[84451834315461, { pathname: '/community/our-staff/chris-bott', name: 'Chris Bott' }],
	[84453341918772, { pathname: '/community/our-staff/will-bray', name: 'Will Bray' }],
	[84455418860411, { pathname: '/community/our-staff/shelley-byrne', name: 'Shelley Byrne' }],
	[84457074332604, { pathname: '/community/our-staff/kath-connolly', name: 'Kath Connolly' }],
	[84711258791358, { pathname: '/community/our-staff/will-goldsmith', name: 'Will Goldsmith' }],
	[84730606975683, { pathname: '/community/our-staff/sian-gorvin', name: 'Sian Gorvin' }],
	[84737221592147, { pathname: '/community/our-staff/christopher-grocock', name: 'Christopher Grocock' }],
	[84738807185386, { pathname: '/community/our-staff/nichola-gotel', name: 'Nichola Gotel' }],
	[84742250492517, { pathname: '/community/our-staff/mary-elizabeth-houghton', name: 'Mary-Elizabeth Houghton' }],
	[84747766486952, { pathname: '/community/our-staff/steve-jeggo', name: 'Steve Jeggo' }],
	[84785571785805, { pathname: '/community/our-staff/darran-kettle', name: 'Darran Kettle' }],
	[84786105269826, { pathname: '/community/our-staff/eva-caiger-smith', name: 'Eva Caiger-Smith' }],
	[84792016831728, { pathname: '/community/our-staff/simon-kingsley-pallant', name: 'Simon Kingsley-Pallant' }],
	[84792448418048, { pathname: '/community/our-staff/spencer-leach', name: 'Spencer Leach' }],
	[84794588257356, { pathname: '/community/our-staff/andrew-martin', name: 'Andrew Martin' }],
	[84797171818902, { pathname: '/community/our-staff/enca-marza-porcar', name: 'Enca Marza Porcar' }],
	[84798144321419, { pathname: '/community/our-staff/katie-mcbride', name: 'Katie McBride' }],
	[84803275269732, { pathname: '/community/our-staff/susan-mcfarlane', name: 'Susan McFarlane' }],
	[84804323579264, { pathname: '/community/our-staff/lucy-mcilwraith', name: 'Lucy McIlwraith' }],
	[84805000250827, { pathname: '/community/our-staff/nicholas-meigh', name: 'Nicholas Meigh' }],
	[84807420090114, { pathname: '/community/our-staff/jennifer-moore', name: 'Jennifer Moore' }],
	[84819604470022, { pathname: '/community/our-staff/jonathan-peers', name: 'Jonathan Peers' }],
	[84820243405127, { pathname: '/community/our-staff/matt-potts', name: 'Matt Potts' }],
	[84821206575435, { pathname: '/community/our-staff/daniel-preece', name: 'Daniel Preece' }],
	[84824458627491, { pathname: '/community/our-staff/fiona-read', name: 'Fiona Read' }],
	[84825267116457, { pathname: '/community/our-staff/rob-reynolds', name: 'Rob Reynolds' }],
	[85934535573099, { pathname: '/community/alumni-hub', name: 'Alumni Hub' }],
	[86178793810072, { pathname: '/community/our-staff/ana-simmons', name: 'Ana Simmons' }],
	[86180171984190, { pathname: '/community/our-staff/liz-stacy', name: 'Liz Stacy' }],
	[86180943338949, { pathname: '/community/our-staff/henry-stoot', name: 'Henry Stoot' }],
	[86498642470774, { pathname: '/community/our-staff/mea-wade', name: 'Mea Wade' }],
	[86502677400020, { pathname: '/community/our-staff/ryan-walsh', name: 'Ryan Walsh' }],
	[86503176976868, { pathname: '/community/our-staff/abi-wharton', name: 'Abi Wharton' }],
	[86503759329773, { pathname: '/community/our-staff/andy-wiggins', name: 'Andy Wiggins' }],
	[86504327917091, { pathname: '/community/our-staff/karena-fulford', name: 'Karena Fulford' }],
	[86508250257428, { pathname: '/community/our-staff/greg-read', name: 'Greg Read' }],
	[86527632666333, { pathname: '/community/our-staff/kate-goldmann', name: 'Kate Goldmann' }],
	[
		89489377203342,
		{
			pathname: '/journal/news/new-bedales-podcast-screen-addiction-and-supporting-young-people',
			name: 'New Bedales podcast - Screen addiction and supporting young people'
		}
	],
	[
		89497060629522,
		{
			pathname: '/journal/news/bedales-replaces-gcses-with-unique-curriculum',
			name: 'Bedales replaces GCSEs with unique curriculum'
		}
	],
	[90894575590093, { pathname: '/living/safeguarding', name: 'Safeguarding' }],
	[91225831909079, { pathname: '/community/activities-courses', name: 'Activities & Courses' }],
	[91241660756049, { pathname: '/introduction/bedales-campus', name: 'Bedales Campus' }],
	[91244189001297, { pathname: '/admissions/apply-to-bedales', name: 'Apply to Bedales' }],
	[91244570294124, { pathname: '/admissions/visit-us', name: 'Visit us' }],
	[91549523720943, { pathname: '/introduction/inspection-reports', name: 'Inspection reports' }],
	[
		91810664160646,
		{
			pathname: '/journal/news/bedales-students-access-top-university-destinations',
			name: 'Bedales students access top university destinations'
		}
	],
	[91843675756166, { pathname: '/whats-on/our-venues', name: 'Our venues' }],
	[92204799677160, { pathname: '/school-fair', name: 'School fair' }],
	[
		92321901644126,
		{ pathname: '/journal/blog/Block-3-Ullswater-trip-2025', name: 'Block 3 Ullswater trip 2025' }
	],
	[
		92325178036793,
		{
			pathname:
				'/journal/news/bedales-podcast-new-episode-leading-food-and-lifestyle-photographer-georgia-glynn-smith-in-conversation',
			name: 'Bedales Podcast new episode - Leading food and lifestyle photographer Georgia Glynn Smith in conversation'
		}
	],
	[92553224350608, { pathname: '/journal/news/bedales-plaudits', name: 'Bedales plaudits' }],
	[93403967062891, { pathname: '/whats-on/whole-school-concert-1', name: 'Whole school concert' }],
	[93404441420652, { pathname: '/whats-on/sixth-form-show-rent', name: 'Sixth Form Show - RENT' }],
	[93590623214873, { pathname: '/journal/news/badley-day-2025', name: 'Badley Day 2025' }],
	[94042378292088, { pathname: '/whats-on/75-ob-reunion', name: '75+ OB Reunion' }],
	[
		94044545780848,
		{
			pathname: '/whats-on/design-lecture-special-conversation-andrew-winch',
			name: 'Design Lecture - A special conversation with Andrew Winch'
		}
	],
	[94046081998846, { pathname: '/whats-on/bedales-fireworks', name: 'Bedales Fireworks' }],
	[94047033360813, { pathname: '/whats-on/bac-theatre-studies-devised-2', name: 'BAC Theatre Studies Devised' }],
	[94047651189449, { pathname: '/whats-on/band-night-4', name: 'Band Night' }],
	[
		94048938546297,
		{
			pathname: '/whats-on/ophelia-immersive-dance-theatre-experience',
			name: 'Ophelia - An Immersive Dance-Theatre Experience'
		}
	],
	[
		94049838207670,
		{ pathname: '/whats-on/zoo-comes-you', name: 'The Zoo That Comes To You - Scarlet Oak Theatre' }
	],
	[94051034872381, { pathname: '/whats-on/st-cecilia-concert-2', name: 'St Cecilia Concert' }],
	[94051649514112, { pathname: '/whats-on/senior-school-show-1984', name: 'Senior School Show - 1984' }],
	[
		94078028711804,
		{
			pathname: '/whats-on/charity-carol-concert-0',
			name: 'Charity Carol Service (with mulled wine and mince pies beforehand)'
		}
	],
	[94079761418606, { pathname: '/whats-on/music-exhibitioners-concert', name: "Music Exhibitioners' Concert" }],
	[95000525675464, { pathname: '/whats-on/will-s-event', name: "Will's event" }],
	[
		96039279761748,
		{
			pathname: '/journal/news/block-1-students-exhibit-artwork-at-petersfield-railway-station',
			name: 'Block 1 students exhibit artwork at Petersfield railway station'
		}
	],
	[
		97165346629102,
		{ pathname: '/journal/galleries/75-ob-reunion-september-2025', name: '75+ OB Reunion - September 2025' }
	],
	[102410512019207, { pathname: '/journal/blog/fireside-folk-and-poetry', name: 'Fireside folk and poetry' }],
	[
		102456750786465,
		{ pathname: '/journal/blog/rent-not-a-school-production', name: 'RENT: Not a school production ' }
	],
	[
		111011642859380,
		{
			pathname: '/journal/blog/a-wonderland-in-the-orchard-bedales-pre-prep-s-magical-summer-production',
			name: "A wonderland in the orchard: Bedales Pre-prep's magical summer production"
		}
	],
	[111349788402626, { pathname: '/community/our-staff/clare-kirkham', name: 'Clare Kirkham' }],
	[
		112394072758753,
		{
			pathname: '/journal/news/bedales-community-joins-together-in-remembrance',
			name: 'Bedales community joins together in Remembrance'
		}
	],
	[
		112400985885638,
		{
			pathname: '/journal/blog/a-home-from-home-revamping-the-sixth-form-dormitories',
			name: 'A home from home: revamping the Sixth Form dormitories '
		}
	],
	[
		112423521903112,
		{
			pathname: '/journal/blog/building-sound-futures-interview-with-acoustician-chris-walls',
			name: 'Building sound futures: interview with Acoustician Chris Walls'
		}
	],
	[
		114813991533439,
		{
			pathname: '/journal/blog/making-magic-real-the-craft-of-theatre-at-bedales',
			name: 'Making magic real: the craft of theatre at Bedales'
		}
	],
	[
		119175264502898,
		{
			pathname: '/journal/news/bedales-inspection-highlights-significant-strength',
			name: 'Bedales inspection highlights significant strength '
		}
	],
	[
		119817239653191,
		{
			pathname: '/journal/blog/bedales-musicians-excel-this-autumn-term',
			name: 'Bedales musicians excel this Autumn term'
		}
	],
	[119821741555383, { pathname: '/journal/blog/perspectives-on-ophelia', name: 'Perspectives on Ophelia' }],
	[
		119841845597944,
		{ pathname: '/journal/blog/blooms-taxonomy-in-the-bakehouse', name: "Bloom's Taxonomy in the Bakehouse" }
	],
	[
		121234226600733,
		{
			pathname: '/whats-on/for-the-love-of-dogs',
			name: 'For the Love of Dogs - Mikey Cantan and Guest Speaker James Middleton'
		}
	],
	[121238824381831, { pathname: '/whats-on/music-scholars-concert-Jan2026', name: "Music Scholars' Concert" }],
	[121239602891558, { pathname: '/whats-on/bedales-prep-show-seussical', name: 'Bedales Prep Show - Seussical' }],
	[121240546123099, { pathname: '/whats-on/bedales-rock-show', name: 'Bedales Rock Show' }],
	[
		121247956939918,
		{
			pathname: '/whats-on/eckersley-lecture',
			name: 'Eckersley Lecture - Professor Lewis Dartnell on Being Human'
		}
	],
	[
		121249491264988,
		{ pathname: '/whats-on/student-directed-performances', name: 'Student Directed Performances' }
	],
	[121251281506802, { pathname: '/whats-on/steinway-and-song-concert', name: 'Steinway and Song Concert' }],
	[
		121251793707819,
		{
			pathname: '/whats-on/bac-theatre-studies-scripted-performances',
			name: 'BAC Theatre Studies Scripted Performances'
		}
	],
	[121259179689188, { pathname: '/whats-on/bedales-dance-performs', name: 'Bedales Dance Performs' }],
	[
		121260028400993,
		{ pathname: '/whats-on/music-exhibitioners-concert-Mar2026', name: "Music Exhibitioners' Concert" }
	],
	[
		121263851107638,
		{
			pathname: '/whats-on/6-2-a-level-theatre-studies-devised-performances',
			name: '6.2 A Level Theatre Studies Devised Performances'
		}
	],
	[
		121264906145636,
		{ pathname: '/whats-on/adventures-in-science-crafty-fools', name: 'Adventures in Science! Crafty Fools' }
	],
	[
		121268084740330,
		{
			pathname: '/whats-on/global-perspectives-lecture-dominic-waghorn',
			name: 'Global Perspectives Lecture - Dominic Waghorn'
		}
	],
	[121270722210492, { pathname: '/whats-on/jazz-cafe', name: 'Jazz Café' }],
	[121271608313421, { pathname: '/whats-on/youth-dance-platform', name: 'Youth Dance Platform' }],
	[121272166229655, { pathname: '/whats-on/spring-concert', name: 'Spring Concert' }],
	[121272862459616, { pathname: '/whats-on/music-scholars-concert-May2026', name: "Music Scholars' Concert" }],
	[
		121273301864111,
		{
			pathname: '/whats-on/6-1-theatre-studies-a-level-devised-productions',
			name: '6.1 Theatre Studies A Level Devised Productions'
		}
	],
	[121273973044865, { pathname: '/whats-on/prep-rock-show', name: 'Prep Rock Show' }],
	[121275070243838, { pathname: '/whats-on/bedales-prep-summer-play', name: 'Bedales Prep Summer Play' }],
	[
		121275952428103,
		{
			pathname: '/whats-on/pieces-of-my-life-by-kirris-riviere-produced-by-ad-infinitum',
			name: 'Pieces of My Life by Kirris Riviere - Produced by Ad Infinitum'
		}
	],
	[
		121276365104206,
		{ pathname: '/whats-on/sebastian-bergne-in-conversation', name: 'Sebastian Bergne in Conversation' }
	],
	[
		121276763288462,
		{
			pathname: '/whats-on/painting-the-roses-red-a-work-in-progress',
			name: 'Painting the Roses Red - A work in progress'
		}
	],
	[
		121277203878850,
		{ pathname: '/whats-on/summer-music-exhibitioners-concert', name: "Summer Music Exhibitioners' Concert" }
	],
	[
		121277620450359,
		{
			pathname: '/whats-on/bedales-senior-summer-show-the-witchfinder-s-daughter',
			name: "Bedales Senior Summer Show - The Witchfinder's Daughter"
		}
	],
	[
		122261607340208,
		{
			pathname: '/journal/blog/visceral-and-immersive-orwells-1984-reimagined-in-the-olivier-theatre',
			name: "Visceral and immersive - Orwell's 1984 reimagined in the Olivier Theatre"
		}
	],
	[
		122264216639915,
		{
			pathname: '/journal/blog/encouraging-critical-thinking-in-pre-lessons',
			name: 'Encouraging critical thinking in PRE lessons'
		}
	],
	[
		134659442278468,
		{
			pathname: '/journal/blog/for-the-love-of-dogs-mikey-cantan-and-james-middleton',
			name: 'For the Love of Dogs - Mikey Cantan and James Middleton'
		}
	],
	[
		136800250282782,
		{
			pathname: '/journal/blog/bedales-community-comes-together-for-coppicing-week',
			name: 'Bedales community comes together for Coppicing Week'
		}
	],
	[
		138608331355740,
		{
			pathname: '/journal/thought-leadership/why-are-top-uk-schools-becoming-more-popular-with-us-families-',
			name: 'Why are top UK schools becoming more popular with US families?'
		}
	],
	[
		139611195879574,
		{
			pathname: '/journal/news/reinventing-education-in-india-brings-arise-to-bedales',
			name: 'Reinventing education in India brings ARISE to Bedales'
		}
	],
	[
		139618535970081,
		{
			pathname: '/journal/blog/the-mysteries-of-the-universe-unravelled-at-cern',
			name: 'The mysteries of the universe, unravelled at CERN'
		}
	],
	[
		141454155109562,
		{ pathname: '/whats-on/watch-the-bedales-rock-show-live-stream-7pm', name: 'Watch the Bedales Rock Show!' }
	],
	[
		143189808008433,
		{
			pathname: '/whats-on/petersfield-jazz-blues-festival-at-bedales',
			name: 'Petersfield Jazz & Blues Festival - at Bedales'
		}
	],
	[
		143923451451493,
		{ pathname: '/journal/news/pandas-spotted-in-the-pre-prep-', name: 'Pandas - spotted in the Pre-prep!' }
	],
	[146650077252967, { pathname: '/community/our-staff/alice-tang-pullen', name: 'Alice Tang-Pullen' }],
	[146655754883601, { pathname: '/community/our-staff/ailsa-mcnaughton', name: 'Ailsa McNaughton' }],
	[149485527832530, { pathname: '/community/our-staff/anthony-davies', name: 'Anthony Davies' }],
	[151259898395938, { pathname: '/whats-on/fun-flippers-splash-camp', name: 'Fun Flippers Splash Camp' }],
	[
		151274128496031,
		{
			pathname: '/whats-on/pompey-in-the-community-football-holiday-courses',
			name: 'Pompey in the Community - Football Holiday Courses'
		}
	],
	[151276893050788, { pathname: '/whats-on/go-sport-activity-camp', name: 'Go Sport Activity Camp' }],
	[
		152022763121727,
		{
			pathname: '/journal/news/student-directed-captivating-theatre-from-our-sixth-form',
			name: 'Student Directed. Captivating theatre from our Sixth Form'
		}
	],
	[
		152039034130059,
		{
			pathname: '/journal/blog/student-directed-captivating-theatre-from-our-sixth-form-rev',
			name: 'Student Directed. Captivating theatre from our Sixth Form'
		}
	],
	[
		153468530885144,
		{
			pathname: '/whats-on/bedales-pastoral-professionals-conference',
			name: "Bedales Pastoral Professionals' Conference"
		}
	],
	[
		153733523871648,
		{
			pathname: '/journal/blog/-brain-day-explores-the-future-of-neuroscience',
			name: "'Brain Day' explores the future of Neuroscience"
		}
	],
	[
		153740482211984,
		{
			pathname: '/journal/blog/a-thrilling-performance-of-pool-no-water-',
			name: "A thrilling performance of 'Pool (no water)'"
		}
	],
	[
		153747665665983,
		{
			pathname: '/journal/blog/rock-show-wrapped-up-and-a-peek-into-our-new-studio',
			name: 'Rock Show wrapped up - and a peek into our new studio'
		}
	],
	[
		154493647857321,
		{
			pathname: '/journal/blog/acclaimed-stained-glass-artist-thomas-denny-leads-a-workshop-at-bedales',
			name: 'Acclaimed stained-glass artist, Thomas Denny, leads a workshop at Bedales'
		}
	],
	[
		156651381100493,
		{
			pathname: '/journal/blog/an-exciting-season-of-cricket-ahead-at-bedales',
			name: 'An exciting season of Cricket ahead at Bedales'
		}
	],
	[
		158070886725742,
		{
			pathname: '/journal/thought-leadership/new-a-practical-guide-to-a-big-education',
			name: "'A Practical Guide to a BIG Education' launched"
		}
	],
	[
		159076077862756,
		{
			pathname: '/journal/news/beyond-bedales-podcast-creating-buildings-that-inspire-learning',
			name: 'Beyond Bedales Podcast: Creating buildings that inspire learning'
		}
	],
	[
		159116199487391,
		{
			pathname: '/journal/blog/3i-explore-the-skies-from-clanfield-observatory',
			name: '3i explore the skies from Clanfield Observatory'
		}
	],
	[
		159497302650498,
		{
			pathname: '/journal/blog/steam-sational-a-week-of-curiosity-creativity-and-cross-curricular-adventure',
			name: 'STEAM-sational! A week of curiosity, creativity and cross-curricular adventure'
		}
	],
	[161209123305017, { pathname: '/admissions/apply-to-bedales/confirmation', name: 'Confirmation' }],
	[
		161216434096301,
		{
			pathname: '/journal/blog/an-exceptional-performance-devised-and-scripted',
			name: 'An exceptional performance, Devised and Scripted'
		}
	],
	[
		165778849061302,
		{
			pathname: '/journal/news/ecctis-highlights-academic-strengths-of-bedales-home-grown-qualifications',
			name: 'Ecctis highlights academic strengths of Bedales home-grown qualifications '
		}
	],
	[
		165842942281381,
		{ pathname: '/community/alumni-hub/alumni-profiles/tamsin-lonsdale', name: 'Tamsin Lonsdale' }
	],
	[165845167444785, { pathname: '/community/alumni-hub/alumni-profiles/richard-lewis', name: 'Richard Lewis' }],
	[
		166179818125219,
		{
			pathname: '/journal/videos/international-boarding-at-bedales-prep',
			name: 'International boarding at Bedales Prep '
		}
	],
	[
		168935767391238,
		{
			pathname: '/journal/blog/what-i-ve-learnt-so-far-about-acting-and-myself',
			name: 'What I’ve learnt so far about acting - and myself'
		}
	],
	[
		169304935276059,
		{
			pathname:
				'/journal/blog/anna-keay-becomes-the-queen-s-official-biographer-continuing-a-bedales-legacy-of-writers',
			name: 'Anna Keay becomes the Queen’s Official Biographer, continuing a Bedales legacy of writers '
		}
	],
	[
		169364716070203,
		{
			pathname: '/in-conversation-with-obs-nicola-harding-and-matthew-rice',
			name: 'In conversation with OBs Nicola Harding and Matthew Rice'
		}
	],
	[
		169371470209040,
		{
			pathname: '/journal/blog/in-conversation-with-obs-nicola-harding-and-matthew-rice',
			name: 'In conversation with OBs Nicola Harding and Matthew Rice'
		}
	],
	[
		171435846304936,
		{
			pathname: '/journal/thought-leadership/will-goldsmith-shares-ecctis-evaluation-highlights-in-isc-blog',
			name: 'Will Goldsmith shares Ecctis evaluation highlights in ISC blog'
		}
	],
	[
		186687506734581,
		{
			pathname: '/whats-on/when-life-gives-you-lemons-everyones-everest',
			name: "Film Screening & Q&A: When Life Gives you Lemons... Everyone's Everest"
		}
	],
	[187779878238454, { pathname: '/parents-day-2026', name: "Parents' Day 2026" }],
	[
		193057165123697,
		{ pathname: '/whats-on/pieces-of-my-life-by-kirris-riviere', name: 'Pieces of My Life by Kirris Riviere' }
	],
	[
		193058833830724,
		{
			pathname: '/whats-on/the-truth-about-trees-apropos-theatre',
			name: 'The Truth About Trees - Apropos Theatre'
		}
	],
	[193060011410779, { pathname: '/whats-on/music-scholars-concert-sep-26', name: "Music Scholars' Concert" }],
	[193060607059424, { pathname: '/whats-on/whole-school-concert', name: 'Whole School Concert' }],
	[
		193061449148548,
		{
			pathname: '/whats-on/rural-refugee-network-10th-anniversary-celebrations',
			name: 'Rural Refugee Network - 10th Anniversary Celebrations'
		}
	],
	[193064602211981, { pathname: '/whats-on/suli-breaks-masculinity', name: 'Suli Breaks - Masculinity' }],
	[193065732435328, { pathname: '/whats-on/sixth-form-show-ink', name: 'Sixth Form Show - Ink' }],
	[193067992375754, { pathname: '/whats-on/the-red-dress', name: 'The Red Dress' }],
	[193068996580494, { pathname: '/whats-on/band-night', name: 'Band Night' }],
	[193070036628704, { pathname: '/whats-on/mr-sleepybum-s-dream-machine', name: "Mr Sleepybum's Dream Machine" }],
	[
		193072028186837,
		{ pathname: '/whats-on/eckersley-lecture-60th-anniversary', name: 'Eckersley Lecture 60th Anniversary ' }
	],
	[
		193072587802856,
		{ pathname: '/whats-on/music-exhibitioners-concert-nov-2026', name: "Music Exhibitioners' Concert" }
	],
	[193074493250369, { pathname: '/whats-on/bac-theatre-studies-devised', name: 'BAC Theatre Studies Devised' }],
	[193075454268269, { pathname: '/whats-on/triptych', name: 'Triptych - dance works by Lewis Major' }],
	[193076481770724, { pathname: '/whats-on/st-cecilia-concert', name: 'St Cecilia Concert' }],
	[
		193077232400074,
		{
			pathname: '/whats-on/senior-school-show-the-great-gatsby-simon-levy-adaptation',
			name: "Senior School Show 'The Great Gatsby' - Simon Levy Adaptation"
		}
	],
	[193078432106546, { pathname: '/whats-on/charity-carol-concert', name: 'Charity Carol Concert' }],
	[
		193364284280863,
		{
			pathname: '/whats-on/stansted-players-friar-bacon-friary-bungay-1589-',
			name: 'Stansted Players - Friar Bacon & Friary Bungay (1589)'
		}
	],
	[
		193721591851738,
		{
			pathname: '/journal/blog/bedales-politics--prize--winners-2026',
			name: 'Bedales Politics Prize winners 2026'
		}
	],
	[
		195600017431515,
		{
			pathname: '/journal/news/bedales-innovative-approach-highlighted-by-bbc-news',
			name: "Bedales' innovative approach highlighted by BBC News"
		}
	],
	[196211689779179, { pathname: '/journal/galleries/parents-day-2026', name: "Parents' Day 2026" }],
	[
		208681612570124,
		{
			pathname: '/journal/news/a-level-success-at-bedales',
			name: 'Independent thinkers and inspiring destinations - A Level success at Bedales'
		}
	],
	[
		211164723263159,
		{
			pathname: '/bedales-continues-to-expand-unique-curriculum-alongside-core-gcses',
			name: 'Bedales continues to expand unique curriculum alongside core GCSEs'
		}
	],
	[
		211170945741104,
		{
			pathname: '/journal/news/bedales-continues-to-expand-unique-curriculum-alongside-core-gcses',
			name: 'Bedales continues to expand unique curriculum alongside core GCSEs'
		}
	],
	[
		211507254010568,
		{
			pathname: '/journal/thought-leadership/time-to-reform-gcses',
			name: 'Time to reform GCSEs - Will Goldsmith'
		}
	],
	[
		212489361781563,
		{
			pathname: '/journal/blog/what-it-really-takes-to-put-on-a-bedales-play',
			name: 'What it really takes to put on a Bedales play'
		}
	],
	[
		212523804245393,
		{
			pathname: '/journal/thought-leadership/if-childhood-has-changed-should-education-change-too-',
			name: 'If childhood has changed, should education change too? '
		}
	],
	[
		213531517014699,
		{
			pathname: '/journal/thought-leadership/what-i-ve-learnt-during-my-first-year-at-bedales-prep',
			name: "What I've learnt during my first year at Bedales Prep"
		}
	],
	[
		215690150229151,
		{
			pathname: '/journal/thought-leadership/the-hidden-curriculum-what-a-school-play-really-teaches',
			name: 'The hidden curriculum: what a school play really teaches'
		}
	],
	[
		218165349536937,
		{
			pathname: '/whats-on/in-conversation-with-b-akerlund',
			name: 'In Conversation with B. Åkerlund: Swedish-born fashion activist and costume designer'
		}
	],
	[221377389873591, { pathname: '/admissions/immersion', name: 'Immersion' }],
	[222805326816865, { pathname: '/support-us/badley-day-2026', name: 'Badley Day 2026' }],
	[
		224875319170722,
		{
			pathname: '/journal/news/national-recognition',
			name: "National recognition for Bedales' distinctive approach"
		}
	],
	[
		225668455485022,
		{
			pathname: '/journal/blog/why-we-ask-11-year-olds-to-make-shakespeare-films',
			name: 'Why we ask 11-year-olds to make Shakespeare films'
		}
	],
	[
		227740732951231,
		{
			pathname: '/whats-on/stage-door-jonny-live-minnie-driver-in-conversation-with-jonathan-cake',
			name: 'Stage Door Jonny Live: Minnie Driver in conversation with Jonathan Cake'
		}
	],
	[235491734887168, { pathname: '/admissions/prospectus-form', name: 'Request a prospectus' }],
	[235990554789208, { pathname: '/', name: 'Prospectus brochure' }]
])
